
<template>
  <vs-row>
    <div class="mt-5 w-full">
      <vs-row class="tabCard">
        <vs-row>
          <h3 class="p-5">{{ pagename }}</h3>
        </vs-row>
        <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
          <div class="addCardFont font-semibold ml-5 mt-6">
            Headline<span v-if="errors.headline.success" class="sterik">
              *</span
            >
            <span v-if="!errors.headline.success"> *</span>
          </div>
          <vs-input
            class="w-full p-4 pt-3 pb-1"
            v-model="promo.headline"
            :danger="errors.headline.success"
            :danger-text="errors.headline.msg"
            @keyup="validateHeadline(promo.headline)"
            maxLength="120"
          />

          <vs-col class="p-4 pt-5 pb-1">
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-col
                  vs-lg="8"
                  vs-sm="8"
                  class="inputContainer max-height-5-24"
                >
                  <div class="addCardFont font-semibold mb-0 mt-0 ml-0">
                    Start Date
                  </div>
                </vs-col>
                <vs-col
                  vs-lg="4"
                  vs-sm="4"
                  class="inputContainer max-height-5-24"
                  vs-type="flex"
                  vs-justify="flex-end"
                >
                  <vs-checkbox
                    v-model="startDateNotAvailable"
                    vs-name="startDateNotAvailable"
                    :vs-value="true"
                    class="mb-3"
                    @click="startDateNotAvailableSelected()"
                  />
                  <div class="addCardFont font-semibold ml-0 mb-0">N/A</div>
                </vs-col>
                <Datepicker
                  :disabled="startDateNotAvailable"
                  v-model="promo.startDate"
                  wrapper-class="p-5 pt-3 pr-0 pl-0 mt-2 pt-0 pb-0 mb-2"
                  calendar-class="posCalendar"
                  input-class="bgColorInput"
                  placeholder="MM/DD/YYYY"
                  format="MM/dd/yyyy"
                />
              </vs-col>
              <div v-show="errors.startDate.success" class="ml-0 mb-3">
                <div id="errFont" class="dangerColor mt-0 ml-1">
                  <span>{{ errors.startDate.msg }}</span>
                </div>
              </div>
            </vs-row>
          </vs-col>
          <vs-col class="p-4 pb-1">
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-col
                  vs-lg="8"
                  vs-sm="8"
                  class="inputContainer max-height-5-24"
                >
                  <div class="addCardFont font-semibold mb-0 mt-0 ml-0">
                    End Date
                  </div>
                </vs-col>
                <vs-col
                  vs-lg="4"
                  vs-sm="4"
                  class="inputContainer max-height-5-24"
                  vs-type="flex"
                  vs-justify="flex-end"
                >
                  <vs-checkbox
                    v-model="endDateNotAvailable"
                    vs-name="endDateNotAvailable"
                    :vs-value="true"
                    class="mb-3"
                    @click="endDateNotAvailableSelected()"
                  />
                  <div class="addCardFont font-semibold ml-0 mb-0">N/A</div>
                </vs-col>
              </vs-col>
              <vs-input
                :disabled="endDateNotAvailable"
                class="w-full p-0 pb-1"
                v-model="endDateContainer"
                @click="(showDetails = true), openShowDetailspopup()"
                maxLength="120"
              />
            </vs-row>
          </vs-col>
          <vs-col v-if="promo.timeZone && promo.time" class="p-4 pt-1 pb-1">
            <vs-row>
              <vs-col class="">
                <div class="addCardFont font-semibold ml-0 mb-0">
                  <vs-row>
                    <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                      <vs-row>
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                          <vs-input
                            class="w-full p-0 pb-1"
                            v-model="promo.timeZone"
                            :danger="errors.timeZone.success"
                            :danger-text="errors.timeZone.msg"
                            @click="
                              (showDetails = true), openShowDetailspopup()
                            "
                            maxLength="120"
                          />
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
                          <vs-row>
                            <vs-input
                              type="text"
                              class="w-full"
                              v-model="promo.time"
                              :danger="errors.time.success"
                              :danger-text="errors.time.msg"
                              @click="showDetails = true"
                            />
                          </vs-row>
                        </vs-col>
                      </vs-row>
                    </vs-col>
                  </vs-row>

                  <span class="select_error_msg" v-if="errors.date.success">
                    {{ errors.date.msg }}</span
                  >
                </div>
              </vs-col>
            </vs-row>
          </vs-col>
          <div v-show="errors.endDate.success" class="ml-4 mb-3">
            <div id="errFont" class="dangerColor mt-0 ml-1">
              <span>{{ errors.endDate.msg }}</span>
            </div>
          </div>

          <vs-row>
            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="addCardFont font-semibold ml-4 mt-5">
                H/T Link Label
              </div>
              <vs-input
                class="w-full p-4 pt-3 pb-1"
                v-model="promo.htLinkLabel"
                :danger="errors.htLinkLabel.success"
                :danger-text="errors.htLinkLabel.msg"
                maxLength="120"
              />
            </vs-col>

            <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
              <div class="addCardFont font-semibold ml-5 mt-5">
                H/T Link URL
              </div>
              <vs-input
                class="w-full p-4 pt-3 pb-1"
                v-model="promo.htLinkUrl"
                :danger="errors.htLinkUrl.success"
                :danger-text="errors.htLinkUrl.msg"
                @input="validateLinkUrl($event), checkinputlink()"
                maxLength="120"
              />
            </vs-col>
          </vs-row>

          <vs-row>
            <div class="dropdown mt-1 w-full" id="dropdown">
              <div class="addCardFont font-semibold ml-4 mt-6">
                Primary Hashtag<span
                  v-if="errors.primaryHashtag.success"
                  class="sterik"
                >
                  *</span
                >
                <span v-if="!errors.primaryHashtag.success"> *</span>
              </div>
              <vs-input
                class="w-full p-4 pt-3 pb-1"
                v-model="promo.primaryHashtag"
                :danger="errors.primaryHashtag.success"
                :danger-text="errors.primaryHashtag.msg"
                @keyup="
                  validatePrimaryHashtag(promo.primaryHashtag),
                    filterPrimaryHashtagFunction(promo.primaryHashtag)
                "
                @click="handlePrimaryHashtagFilter"
                @keypress="handlePrimaryHashtagFilter"
                @keypress.enter="closePrimaryHashtagList()"
                v-on-clickaway="closePrimaryHashtagList"
                maxLength="120"
              />

              <div class="dropdown-content" v-show="togglePrimaryHashtagList">
                <div
                  class=""
                  @click="
                    (promo.primaryHashtag = hashtag.name),
                      checkphoto(),
                      validatePrimaryHashtag(promo.primaryHashtag)
                  "
                  :key="index"
                  v-for="(hashtag, index) in primaryHashtagList"
                >
                  <h6 class="my-2">
                    {{ "#" + hashtag.name }}
                  </h6>
                </div>
              </div>
            </div>
          </vs-row>

          <vs-row>
            <vs-row>
              <div class="addCardFont font-semibold mb-3 mt-6 ml-4">
                Primary Hashtag Logo
              </div>
            </vs-row>
            <vs-row
              class="p-0 pl-0 pt-0 m-3 mt-0 pb-0 ml-4 mb-1"
              vs-type="flex"
              vs-justify="flex-start"
            >
              <vs-col vs-lg="10">
                <div
                  @click="$refs.uploadAddCard1.click()"
                  class="uploadLabelWizard"
                >
                  {{
                    promo.primaryHashtagPhoto &&
                    photoChangeFlag == false &&
                    ($route.params.data != undefined || isPhotoExisting == true)
                      ? promo.primaryHashtagPhoto
                          .toString()
                          .split("\\")

                          .pop()
                      : promo.primaryHashtagPhoto
                      ? promo.primaryHashtagPhoto.name
                      : "Upload Logo Picture"
                  }}
                </div>
                <input
                  type="file"
                  class="hidden"
                  ref="uploadAddCard1"
                  @change="showFilePathPrimaryHashtag"
                />
              </vs-col>
              <!-- @change="showFilePath" -->
              <vs-col vs-lg="2" class="uploadContainerAddWizard">
                <div class="btn-addon">
                  <vs-button
                    size="small"
                    color="primary"
                    @click="$refs.uploadAddCard1.click()"
                  >
                    <UploadCloudIcon />
                  </vs-button>
                </div>
              </vs-col>
              <vs-row class="pl-6 ml-6">
                <div
                  v-show="errors.primaryHashtagphoto.success"
                  class="ml-6 pl-6"
                >
                  <div id="errFont" class="dangerColor mt-3">
                    <span class="ml-6 pl-6">{{
                      errors.primaryHashtagphoto.msg
                    }}</span>
                  </div>
                </div>
              </vs-row>
            </vs-row>
          </vs-row>
          <vs-row v-if="promo.primaryHashtagPhoto" class="ml-4 mt-2">
            <!-- <vue-load-image>
              <img
                v-if="promo.primaryHashtagPhoto"
                slot="image"
                :src="
                  promo.primaryHashtagPhoto
                    ? $ApiKeys.IMAGE_BASE_URL + promo.primaryHashtagPhoto
                    : require('@/assets/images/no_preview.jpg')
                "
                height="42"
                width="90"
              />
            </vue-load-image> -->
            <vue-load-image>
              <img
                v-if="photoChangeFlag == false"
                slot="image"
                :src="
                  promo.primaryHashtagPhoto
                    ? $ApiKeys.IMAGE_BASE_URL + promo.primaryHashtagPhoto
                    : require('@/assets/images/no_preview.jpg')
                "
                height="42"
                width="90"
                @click="
                  imageclicked($ApiKeys.IMAGE_BASE_URL + promo.primaryHashtagPhoto)
                "
              />
              <img
                v-if="photoChangeFlag == true"
                slot="image"
                :src="previewPrimary"
                height="42"
                width="90"
                @click="imageclicked(previewPrimary)"
              />

              <img
                slot="preloader"
                src="@/assets/images/image-loader.gif"
                height="42"
                width="90"
              />
              <div slot="error">
                <img
                  slot="image"
                  :src="require('@/assets/images/no_preview.jpg')"
                  height="42"
                  width="90"
                />
              </div>
            </vue-load-image>
          </vs-row>
          <vs-row>
            <div class="dropdown mt-1 w-full" id="dropdown">
              <div class="addCardFont font-semibold ml-4 mt-5">
                Secondary Hashtags
              </div>
              <vs-input
                class="w-full p-4 pt-3 pb-1"
                v-model="hashtext"
                :danger="errors.hashtags.success"
                :danger-text="errors.hashtags.msg"
                @click="handleFilter"
                @keypress="handleFilter"
                @keypress.enter="addHashtags(hashtext), closeColorList()"
                v-on-clickaway="closeColorList"
                @keyup="
                  validateSecondaryHashtagtext(hashtext),
                    filterFunction(hashtext)
                "
                maxLength="120"
              />

              <div class="dropdown-content" v-show="toggleColorList">
                <div
                  class=""
                  @click="addHashtags(hashtag.name)"
                  :key="index"
                  v-for="(hashtag, index) in hashtaglistshow"
                >
                  <h6 class="my-2">{{ "#" + hashtag.name }}</h6>
                </div>
              </div>
            </div>
          </vs-row>
          <vs-row class="ml-4 mt-2">
            <div>
              <vs-chip
                color="primary"
                @click="remove(chip), filterFunction('')"
                v-for="chip in hashtags"
                :key="chip"
                closable
              >
                {{ "#" + chip }}
              </vs-chip>
            </div>
          </vs-row>

          <vs-row>
            <div class="dropdown mt-0 w-full" id="dropdown">
              <!-- <div class="addCardFont font-semibold ml-4 mt-4">
                Promo Category
              </div> -->
              <div class="addCardFont font-semibold ml-4 mt-6">
                Promo Category<span
                  v-if="errors.promoCategoryList.success"
                  class="sterik"
                >
                  *</span
                >
                <span v-if="!errors.promoCategoryList.success"> *</span>
              </div>
              <vs-input
                class="w-full p-4 pt-3 pb-1"
                v-model="promoCategoryText"
                :danger="errors.promoCategoryList.success"
                :danger-text="errors.promoCategoryList.msg"
                @click="handlePromoCategoryFilter"
                @keypress="handlePromoCategoryFilter"
                @keypress.enter="
                  addPromoCategoryItem(promoCategoryText),
                    closePromoCategoryList()
                "
                v-on-clickaway="closePromoCategoryList"
                @keyup="filterFunctionPromoCategory(promoCategoryText)"
                maxLength="120"
              />

              <div class="dropdown-content" v-show="togglePromoCategoryList">
                <div
                  class=""
                  @click="addPromoCategoryItem(promoCat.name)"
                  :key="index"
                  v-for="(promoCat, index) in promoCategoryListshow"
                >
                  <h6 class="my-2">{{ promoCat.name }}</h6>
                </div>
              </div>
            </div>
          </vs-row>
          <vs-row class="ml-4 mt-2">
            <div>
              <vs-chip
                color="primary"
                @click="
                  removePromoCategory(chip), filterFunctionPromoCategory('')
                "
                v-for="chip in newpromoCategoryArray"
                :key="chip"
                closable
              >
                {{ chip }}
              </vs-chip>
            </div>
          </vs-row>
          <vs-row
            v-if="
              promo.is_created_by != undefined && promo.is_created_by == 'user'
            "
          >
            <div class="addCardFont font-semibold ml-5 mt-4">Promo URL</div>
            <vs-input
              class="w-full p-4 pt-3 pb-1"
              v-model="promo.promoUrl"
              :danger="errors.promoUrl.success"
              :danger-text="errors.promoUrl.msg"
              @keyup="validateLinkUrl(promo.promoUrl)"
              maxLength="120"
            />
          </vs-row>
          <!-- </vs-row> -->
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="inputContainer mt-4">
          <vs-row>
            <vs-col
              vs-lg="5"
              vs-sm="5"
              class="inputContainer max-height-5-24 pb-1 mt-3"
            >
              <div class="mt-4 mb-0">
                <vs-col
                  vs-lg="12"
                  vs-sm="12"
                  class="inputContainer max-height-5-24 pr-5 mt-4"
                  vs-type="flex"
                  vs-justify="flex-start"
                >
                  <vs-checkbox
                    v-model="promo.displayOnDash"
                    vs-name="displayOnDash"
                    :vs-value="true"
                    class="mb-5 ml-5"
                  />
                  <div class="addCardFont font-semibold ml-0 mb-5">
                    Display on Dash
                  </div>
                </vs-col>
              </div>
            </vs-col>
            <vs-col
              vs-lg="7"
              vs-sm="7"
              class="inputContainer max-height-5-24 mt-3"
              vs-type="flex"
              vs-justify="flex-end"
            >
              <div class="mt-4 mb-0">
                <vs-col
                  vs-lg="12"
                  vs-sm="12"
                  class="inputContainer max-height-5-24 pr-5 mt-4"
                  vs-type="flex"
                  vs-justify="flex-start"
                >
                  <vs-checkbox
                    v-model="promo.promoAttachedToCard"
                    vs-name="promoAttachedToCard"
                    :vs-value="true"
                    class="mb-5 ml-5"
                  />
                  <div class="addCardFont font-semibold ml-0 mb-5">
                    Promo must be attached to a card
                  </div>
                </vs-col>
              </div>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col
              vs-lg="8"
              vs-sm="8"
              class="inputContainer max-height-5-24 pb-1 mt-3"
            >
              <div class="addCardFont font-semibold">
                <vs-col>
                  <vs-row>
                    <div class="addCardFont font-semibold ml-5 mt-2">
                      Targeted Status
                      <span v-if="errors.targetedStatus.success" class="sterik">
                        *</span
                      >
                    </div>
                  </vs-row>
                  <vs-row class="">
                    <vs-radio
                      v-model="promo.targetedStatus"
                      vs-name="targetedSatusYes"
                      vs-value="yes"
                      class="ml-5 mr-5 addCardFont textSize"
                      @change="promo.targetedStatus = 'yes'"
                      >Yes
                    </vs-radio>
                    <vs-radio
                      v-model="promo.targetedStatus"
                      vs-name="targetedSatusNo"
                      vs-value="no"
                      class="mr-5 ml-5 addCardFont textSize"
                      @change="promo.targetedStatus = 'no'"
                    >
                      No
                    </vs-radio>
                    <vs-radio
                      v-model="promo.targetedStatus"
                      vs-name="targetedSatusMaybe"
                      vs-value="maybe"
                      class="m-5 ml-15 addCardFont textSize"
                      @change="promo.targetedStatus = 'maybe'"
                      >Maybe
                    </vs-radio>
                  </vs-row>
                  <span
                    class="select_error_msg ml-5 pb-5"
                    v-if="errors.targetedStatus.success"
                  >
                    {{ errors.targetedStatus.msg }}</span
                  >
                </vs-col>
              </div>
            </vs-col>
          </vs-row>

          <vs-row>
            <div class="addCardFont font-semibold mb-3 mt-4 ml-5">Logo</div>
          </vs-row>
          <vs-row
            class="p-5 pl-0 pt-0 m-5 mt-0 pb-0 mb-6"
            vs-type="flex"
            vs-justify="flex-start"
          >
            <vs-col vs-lg="6">
              <div
                @click="$refs.uploadAddCard.click()"
                class="uploadLabelWizard"
              >
                {{
                  promo.photo &&
                  !photoChangeFlag2 &&
                  $route.params.data != undefined
                    ? promo.photo.split("\\").pop()
                    : promo.photo
                    ? promo.photo.name
                    : "Upload Logo Picture"
                }}
                <!-- {{ promo.photo ? promo.photo.name : "Upload Logo Picture" }} -->
              </div>
              <input
                type="file"
                class="hidden"
                ref="uploadAddCard"
                @change="showFilePath"
              />
            </vs-col>
            <!-- @change="showFilePath" -->
            <vs-col vs-lg="2" class="uploadContainerAddWizard">
              <div class="btn-addon">
                <vs-button
                  size="small"
                  color="primary"
                  @click="$refs.uploadAddCard.click()"
                >
                  <UploadCloudIcon />
                </vs-button>
              </div>
            </vs-col>
            <vs-row class="pl-6 ml-6">
              <div v-show="errors.photo.success" class="ml-6 pl-6">
                <div id="errFont" class="dangerColor mt-3">
                  <span class="ml-6 pl-6">{{ errors.photo.msg }}</span>
                </div>
              </div>
            </vs-row>
          </vs-row>

          <vs-row v-if="promo.photo" class="ml-6 mt-0 mb-2">
            <!-- <vue-load-image>
              <img
                v-if="promo.photo"
                slot="image"
                :src="
                  promo.photo
                    ? $ApiKeys.IMAGE_BASE_URL + promo.photo
                    : require('@/assets/images/no_preview.jpg')
                "
                height="42"
                width="90"
              />
            </vue-load-image> -->

            <vue-load-image>
              <img
                v-if="photoChangeFlag2 == false"
                slot="image"
                :src="
                  promo.photo
                    ? $ApiKeys.IMAGE_BASE_URL + promo.photo
                    : require('@/assets/images/no_preview.jpg')
                "
                height="42"
                width="90"
                @click="imageclicked($ApiKeys.IMAGE_BASE_URL + promo.photo)"
              />
              <img
                v-if="photoChangeFlag2 == true"
                slot="image"
                :src="preview"
                height="42"
                width="90"
                @click="imageclicked(preview)"
              />
              <img
                slot="preloader"
                src="@/assets/images/image-loader.gif"
                height="42"
                width="90"
              />
              <div slot="error">
                <img
                  slot="image"
                  :src="require('@/assets/images/no_preview.jpg')"
                  height="42"
                  width="90"
                />
              </div>
            </vue-load-image>
          </vs-row>

          <vs-col class="p-4 pt-0 pb-2 ml-1">
            <div class="addCardFont font-semibold mb-3">Short Description</div>
            <vs-textarea
              id="textare"
              style="background-color: #rgb(52, 52, 52) !important"
              placeholder="e.g. spend $3000 in the first three months"
              rows="3"
              v-model="promo.shortDescription"
              :danger="errors.shortDescription.success"
              :danger-text="errors.shortDescription.msg"
            />
          </vs-col>
          <vs-col class="p-4 pt-0 pl-1 pr-5 pb-2 ml-0">
            <div class="ml-4 addCardFont font-semibold mb-3">
              Long Description
            </div>
            <!-- <vs-textarea
              id="textareLong"
              style="background-color: #rgb(52, 52, 52) !important"
              placeholder="e.g. spend $3000 in the first three months"
              v-model="promo.longDescription"
              :danger="errors.longDescription.success"
              :danger-text="errors.longDescription.msg"
            /> -->
            <!-- <vs-row> -->
            <!-- <div class="addCardFont ml-4 font-semibold cursor">
                    Points Description
                  </div> -->

            <Editor
              v-model="promo.longDescription"
              api-key="oeikwgxzj7ibe8ex4s9ubifc69hoiq52wjylhhoe8c4nr0no"
              :init="{
                selector: 'textarea',
                content_style: 'body, body a { color: white }',
                width: '99%',
                menubar: false,
                plugins: 'link paste autolink',
                toolbar: 'bold italic underline strikethrough | link anchor',
              }"
            />
            <!-- </vs-row> -->
          </vs-col>
          <vs-col v-if="promo.screenshot" class="p-4 pt-3 pl-1 pr-5 pb-2 ml-0">
            <div class="ml-4 addCardFont font-semibold mb-3">Screenshot</div>
            <div class="ml-4 addCardFont font-semibold mb-3">
              <vue-load-image>
                <img
                  slot="image"
                  style="border-radius: 4px"
                  :src="
                    promo.screenshot
                      ? $ApiKeys.IMAGE_BASE_URL + promo.screenshot
                      : require('@/assets/images/no_preview.jpg')
                  "
                  width="75"
                  height="75"
                  @click="imageclicked($ApiKeys.IMAGE_BASE_URL + promo.screenshot)"
                />
                <img
                  slot="preloader"
                  style="border-radius: 4px"
                  src="@/assets/images/image-loader.gif"
                  width="75"
                  height="75"
                />
                <div slot="error">
                  <img
                    slot="image"
                    style="border-radius: 4px"
                    :src="require('@/assets/images/no_preview.jpg')"
                    width="75"
                    height="75"
                  />
                </div>
              </vue-load-image>
            </div>
            <!-- </vs-row> -->
          </vs-col>
        </vs-col>
        <vs-col vs-lg="6" vs-sm="12" class="inputContainer mt-5 pt-5">
          <vs-row>
            <vs-row class="pt-5 mt-5">
              <h3 class="p-5 pb-0">Stacks</h3>
            </vs-row>
            <vs-row
              v-if="showStack != true || isStackAndPromoDataLoaded != true"
            >
              <vs-row v-if="showStack != true">
                <div class="mt-4 mb-0">
                  <vs-col
                    vs-lg="12"
                    vs-sm="12"
                    class="inputContainer max-height-5-24 pr-5 mt-4"
                    vs-type="flex"
                    vs-justify="flex-start"
                  >
                    <vs-checkbox
                      v-model="showStack"
                      vs-name="showStack"
                      class="mb-5 ml-5"
                      @click="getCardsAndPromos"
                    />
                    <div class="addCardFont font-semibold ml-0 mb-5">
                      Add Linked Promos / Credit And Perks
                    </div>
                  </vs-col>
                </div>
              </vs-row>
              <vs-row
                v-if="showStack == true && isStackAndPromoDataLoaded != true"
              >
                <div class="mt-4 mb-0">
                  <vs-col
                    vs-lg="12"
                    vs-sm="12"
                    class="inputContainer max-height-5-24 pr-5 mt-4"
                    vs-type="flex"
                    vs-justify="flex-start"
                  >
                    <vs-checkbox
                      v-model="isStackAndPromoDataLoaded"
                      vs-name="isStackAndPromoDataLoaded"
                      class="mb-5 ml-5"
                      @click="getCardsAndPromos"
                    />
                    <div class="addCardFont font-semibold ml-0 mb-5">
                      Add Linked Promos / Credit And Perks
                    </div>
                  </vs-col>
                </div>
              </vs-row>
            </vs-row>
            <!-- <vs-col vs-lg="6" vs-sm="12" class="inputContainer"> -->
            <vs-row class="p-4 pt-2">
              <div class="addCardFont font-semibold ml-0 mt-5 my-2 pt-1 ml-0">
                Bonus Category
              </div>

              <select
                v-if="point_categoriesList && point_categoriesList.length >= 0"
                :class="{
                  'w-full posSelect  pl-3': true,
                }"
                v-model="promo.bonusCategoryId"
                @change="PopulateCreditPerks(promo.bonusCategoryId)"
              >
                <option
                  v-for="categor in point_categoriesList"
                  :key="categor._id"
                  :value="categor._id"
                >
                  {{ categor.name }}
                </option>
              </select>
            </vs-row>
            <div v-show="errors.bonusCategoryId.success" class="ml-4 mb-3">
              <div id="errFont" class="dangerColor mt-0 ml-1">
                <span>{{ errors.bonusCategoryId.msg }}</span>
              </div>
            </div>
            <!-- </vs-col> -->
          </vs-row>
        </vs-col>

        <vs-row v-if="showStack == true">
          <vs-row>
            <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
              <vs-row v-if="isStackAndPromoDataLoaded == true">
                <h5 class="p-5 pl-4 pb-0">Promos</h5>
              </vs-row>
            </vs-col>
            <vs-row>
              <vs-col
                v-if="isStackAndPromoDataLoaded == true"
                vs-lg="6"
                vs-sm="12"
                class="inputContainer"
              >
                <vs-row>
                  <div class="dropdown mt-1 w-full" id="dropdown">
                    <div class="addCardFont font-semibold ml-4 mt-5">
                      Search Hashtag to Add Promos
                    </div>
                    <vs-input
                      class="w-full p-4 pt-3 pb-1"
                      v-model="promoTextwithHash"
                      @click="handlePromoList"
                      v-on-clickaway="closePromoList"
                      @keyup="
                        validateAddPromotext(
                          promoTextwithHash
                            .toString()
                            .substring(1, promoTextwithHash.length)
                        ),
                          filterPromoList(
                            promoTextwithHash
                              .toString()
                              .substring(1, promoTextwithHash.length)
                          )
                      "
                      @keyup.esc="escapePressed(promoTextwithHash)"
                      @keyup.delete="escapePressed(promoTextwithHash)"
                      maxLength="120"
                    />

                    <!-- <div class="dropdown-content" v-show="toggleColorList">
                    <div
                      class=""
                      @click="addHashtags(hashtag.name)"
                      :key="index"
                      v-for="(hashtag, index) in hashtaglistshow"
                    >
                      <h6 class="my-2">{{ hashtag.name }}</h6>
                    </div>
                  </div> -->
                    <div
                      vs-name="pickerRow"
                      class="dropdown-content-promo"
                      v-show="togglePromoList"
                    >
                      <vs-row
                        vs-name="pickerRow"
                        class=""
                        :key="index"
                        v-for="(promo, index) in promoList"
                      >
                        <vs-col vs-name="pickerRow" vs-lg="12">
                          <vs-row
                            vs-name="pickerRow"
                            id="promoList+index"
                            class="mt-3 mb-1"
                          >
                            <vs-col vs-name="pickerRow" class="mt-1" vs-lg="1">
                              <vs-checkbox
                                v-model="promoList[index].isSelected"
                                vs-name="{promo.isSelected+index}"
                                :vs-value="true"
                                class="mb-5 ml-0"
                                @click="populateStackPromo(index, 'checkbox')"
                              />
                            </vs-col>

                            <vs-col vs-name="pickerRow" vs-lg="10">
                              <vs-row
                                vs-name="pickerRow"
                                id="promoList+index"
                                class="whiteText"
                                @click.native="
                                  populateStackPromo(index, 'none')
                                "
                              >
                                <h6
                                  vs-name="pickerRow"
                                  id="promoList+index"
                                  class="whiteText mb-1"
                                >
                                  {{ promo.headline }}
                                </h6>
                              </vs-row>
                              <vs-row
                                vs-name="pickerRow"
                                id="promoList+index"
                                v-if="promo.short_description"
                                @click.native="
                                  populateStackPromo(index, 'none')
                                "
                              >
                                <p vs-name="pickerRow" id="promoList+index">
                                  {{
                                    promo.short_description &&
                                    promo.short_description.length > 48
                                      ? promo.short_description
                                          .toString()
                                          .substring(0, 48) + "..."
                                      : promo.short_description
                                  }}
                                </p>
                              </vs-row>
                            </vs-col>
                          </vs-row>
                        </vs-col>
                        <vs-row>
                          <vs-col
                            vs-name="pickerRow"
                            class="border-top-perk ml-0"
                            vs-lg="12"
                          >
                          </vs-col>
                        </vs-row>
                      </vs-row>
                    </div>
                  </div>
                </vs-row>
              </vs-col>
              <vs-row>
                <div v-show="errors.linkedPromo.success" class="ml-0 mb-3">
                  <div id="errFont" class="dangerColor mt-3 ml-4">
                    <span>{{ errors.linkedPromo.msg }}</span>
                  </div>
                </div>
              </vs-row>
              <vs-row v-if="linkedPromos.length > 0">
                <vs-col vs-lg="6" vs-sm="12" class="inputContainer">
                  <div class="addCardFont font-semibold ml-4 mt-5">
                    <h6>Linked Promos</h6>
                  </div>
                </vs-col>
              </vs-row>
              <vs-row
                :key="index"
                v-for="(promo, index) in linkedPromos"
                class="addCardFont font-semibold"
              >
                <vs-col
                  vs-lg="6"
                  vs-sm="6"
                  vs-xs="6"
                  class="inputContainer w-full p-4 pr-12 pt-3 pb-1"
                >
                  <vs-row>
                    <vs-col vs-lg="12">
                      <p>Promo {{ index + 1 }}</p>
                    </vs-col>
                  </vs-row>

                  <vs-row>
                    <vs-col
                      vs-lg="6"
                      vs-sm="9"
                      vs-xs="8"
                      class="promoField mt-2 mb-0"
                    >
                      <vs-row class="ml-4 mt-4">
                        <div v-if="linkedPromos[index].promoid">
                          <h6>
                            {{ linkedPromos[index].promoHeadline }}
                          </h6>
                        </div>
                      </vs-row>
                      <vs-row class="ml-4 mt-1 mb-4">
                        <div v-if="linkedPromos[index].promoid">
                          <p>
                            {{
                              linkedPromos[index].shortDescription &&
                              linkedPromos[index].shortDescription.length > 60
                                ? linkedPromos[index].shortDescription
                                    .toString()
                                    .substring(0, 60) + "..."
                                : linkedPromos[index].shortDescription
                            }}
                          </p>
                        </div>
                      </vs-row>
                      <!-- <vs-col v-if="linkedPromos[index].promoid">
                    <div class="addCardFont font-semibold ml-0 mt-4">
                      Promo Headline
                    </div>
                    <vs-input
                      class="w-full p-4 pl-0 pb-1"
                      v-model="linkedPromos[index].promoHeadline"
                      maxLength="120"
                      disabled
                    />
                  </vs-col>
                  <vs-col
                    v-if="linkedPromos[index].promoid"
                    class="p-4 pl-0 pb-2"
                  >
                    <div class="addCardFont font-semibold mb-4">
                      Short Description
                    </div>
                    <vs-textarea
                      id="textaredisabled"
                      style="background-color: #282828 !important"
                      rows="3"
                      v-model="linkedPromos[index].shortDescription"
                      disabled
                    />
                  </vs-col> -->
                    </vs-col>
                    <vs-col vs-lg="3" vs-sm="3" vs-xs="3">
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          cursor
                          mt-8
                          pl-4
                        "
                        @click="removePromo(index)"
                      >
                        <MinusSquareIcon color="white" class="mt-0" />
                        <div class="addCardFont font-semibold ml-4 cursor mt-0">
                          Remove
                        </div>
                      </div>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </vs-row>
          </vs-row>
          <vs-row>
            <vs-col class="border-top ml-4 mt-5" vs-lg="10"> </vs-col>
            <vs-row>
              <h5 class="p-5 pl-4">Credits/Perks</h5>
            </vs-row>
            <vs-col vs-lg="12" vs-sm="12" class="inputContainer">
              <vs-row class="p-4 pt-0 pr-6">
                <vs-row v-if="isStackAndPromoDataLoaded == true">
                  <div
                    class="
                      flex flex-wrap-reverse
                      items-center
                      ml-0
                      cursor
                      mt-4
                      mb-3
                      pt-0
                    "
                    @click="addCreditCard"
                  >
                    <PlusSquareIcon color="white" />
                    <h6 class="ml-2 mt-1 cursor">Add Credit Card</h6>
                  </div>
                </vs-row>
                <vs-row
                  :key="index"
                  v-for="(promo, index) in credits_perks"
                  class="mt-5"
                >
                  <vs-col
                    vs-lg="9"
                    vs-sm="12"
                    vs-xs="12"
                    vs-type="flex"
                    vs-justify="flex-start"
                  >
                    <h6>Credit Card {{ index + 1 }}</h6>
                  </vs-col>

                  <!-- <vs-col vs-lg="9" vs-sm="9"> -->
                  <vs-row>
                    <!-- <vs-col> -->
                    <vs-col>
                      <vs-row>
                        <div class="addCardFont font-semibold my-3 pt-1 ml-0">
                          Credit Card Name
                        </div>
                      </vs-row>
                      <vs-col
                        vs-lg="6"
                        vs-sm="9"
                        vs-xs="8"
                        class="inputContainer p-4 pr-3 pt-0 pl-0 pb-1"
                      >
                        <!-- <select
                        v-if="cardsList.length >= 0"
                        :class="{
                          'w-full posSelect pl-3': true,
                        }"
                        v-model="credits_perks[index].cardId"
                        @change="creditCardSelected(index)"
                      >
                        <option
                          v-for="card in cardsList"
                          :key="card._id"
                          :value="card._id"
                        >
                          {{ card.name }}
                        </option>
                      </select> -->
                        <div class="dropdown mt-0 w-full" id="dropdown">
                          <!-- <div class="addCardFont font-semibold ml-0 mt-5">
                          Search Hashtag to Add Promos
                        </div> -->
                          <vs-input
                            class="w-full"
                            v-model="credits_perks[index].cardName"
                            @click="handleCreditCardToggle(index)"
                            v-on-clickaway="closeCreditCardList(index)"
                            @keyup="keyupCreditCard(index)"
                            maxLength="120"
                          />
                          <div
                            vs-name="pickerRow"
                            class="dropdown-content"
                            v-show="
                              toggleCreditCardList &&
                              credits_perks[index].toggleCreditCardList == true
                            "
                          >
                            <vs-row
                              vs-name="pickerRow"
                              class=""
                              :key="Cardindex"
                              v-for="(card, Cardindex) in cardsList"
                            >
                              <vs-col vs-name="pickerRow" vs-lg="12">
                                <vs-row
                                  vs-name="pickerRow"
                                  id="promoList+index"
                                  class="mt-3 mb-1"
                                >
                                  <vs-col
                                    vs-name="pickerRow"
                                    class="mt-0 img-container"
                                    vs-lg="2"
                                  >
                                    <vue-load-image>
                                      <img
                                        slot="image"
                                        :src="
                                          card.photo
                                            ? $ApiKeys.IMAGE_BASE_URL + card.photo
                                            : require('@/assets/images/no_preview.jpg')
                                        "
                                        width="70"
                                        height="42"
                                      />
                                      <img
                                        slot="preloader"
                                        src="@/assets/images/image-loader.gif"
                                        width="70"
                                        height="42"
                                      />
                                      <div slot="error">
                                        <img
                                          slot="image"
                                          :src="
                                            require('@/assets/images/no_preview.jpg')
                                          "
                                          width="70"
                                          height="42"
                                        />
                                      </div>
                                    </vue-load-image>
                                  </vs-col>

                                  <vs-col
                                    style="margin-left: 8px; margin-top: 2px"
                                    vs-name="pickerRow"
                                    vs-lg="9"
                                    class="pl-5"
                                  >
                                    <vs-row
                                      vs-name="pickerRow"
                                      id="promoList+index"
                                      class="whiteText"
                                      @click.native="
                                        populateStackCreditCard(
                                          Cardindex,
                                          index
                                        ),
                                          MaincloseCreditCardList(index)
                                      "
                                    >
                                      <h6
                                        vs-name="pickerRow"
                                        id="promoList+index"
                                        class="whiteText mb-1"
                                      >
                                        {{ card.name }}
                                      </h6>
                                    </vs-row>
                                    <vs-row
                                      vs-name="pickerRow"
                                      id="promoList+index"
                                      v-if="card.issuer.name"
                                      @click.native="
                                        populateStackCreditCard(
                                          Cardindex,
                                          index
                                        ),
                                          MaincloseCreditCardList(index)
                                      "
                                    >
                                      <p
                                        vs-name="pickerRow"
                                        id="promoList+index"
                                      >
                                        {{ card.issuer.name }}
                                      </p>
                                    </vs-row>
                                  </vs-col>
                                </vs-row>
                              </vs-col>
                              <vs-row>
                                <vs-col
                                  vs-name="pickerRow"
                                  class="border-top-perk ml-0"
                                  vs-lg="12"
                                >
                                </vs-col>
                              </vs-row>
                            </vs-row>
                          </div>
                        </div>
                      </vs-col>
                      <vs-col vs-lg="3" vs-sm="3">
                        <div
                          class="
                            flex flex-wrap-reverse
                            items-center
                            cursor
                            mt-2
                            pl-1
                          "
                          @click="removeCreditCard(index)"
                        >
                          <MinusSquareIcon color="white" class="mt-0" />
                          <div
                            class="addCardFont font-semibold ml-3 cursor mt-0"
                          >
                            Remove
                          </div>
                        </div>
                      </vs-col>
                    </vs-col>
                  </vs-row>

                  <!-- <vs-col class="p-4 pl-0 pb-1"> -->
                  <vs-col>
                    <vs-row>
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-0
                          cursor
                          mt-4
                          mb-3
                          pt-0
                        "
                        @click="addCredits(index)"
                      >
                        <PlusSquareIcon color="white" />
                        <h6 class="ml-2 mt-1 cursor">Add Credits</h6>
                      </div>
                    </vs-row>
                    <vs-row
                      :key="index1"
                      v-for="(credits, index1) in credits_perks[index].credits"
                      class="mt-3"
                    >
                      <vs-col
                        vs-lg="12"
                        vs-sm="12"
                        vs-xs="12"
                        vs-type="flex"
                        vs-justify="flex-start"
                        class="addCardFont font-semibold ml-0 mt-0 mb-3"
                      >
                        <div class="addCardFont font-semibold">
                          Credit {{ index1 + 1 }}
                        </div>
                      </vs-col>

                      <vs-row>
                        <vs-col>
                          <!-- <vs-col vs-lg="9" class="p-2 pt-0 pl-0 pb-1"> -->
                          <!-- <vs-col class="p-4 pt-0 pl-0 pb-1"> -->
                          <vs-col
                            vs-lg="6"
                            vs-sm="9"
                            vs-xs="8"
                            class="inputContainer p-4 pt-0 pl-0 pb-1"
                          >
                            <select
                              v-if="
                                credits_perks[index].creditsList.length >= 0
                              "
                              :class="{
                                'w-full posSelect pl-3': true,
                              }"
                              v-model="
                                credits_perks[index].credits[index1].creditId
                              "
                              @change="StackCreditsChange(index, index1)"
                            >
                              <option
                                v-for="credit in credits_perks[index]
                                  .creditsList"
                                :key="
                                  credit.unique_fee_categories_id
                                    ? credit.unique_fee_categories_id
                                    : credit._id
                                "
                                :value="
                                  credit.unique_fee_categories_id
                                    ? credit.unique_fee_categories_id
                                    : credit._id
                                "
                              >
                                {{ credit.credit_title }}
                              </option>
                            </select>
                          </vs-col>
                          <vs-col vs-lg="3" vs-sm="3">
                            <div
                              class="
                                flex flex-wrap-reverse
                                items-center
                                cursor
                                mt-2
                                pl-1
                              "
                              @click="removeCredit(index, index1)"
                            >
                              <MinusSquareIcon color="white" class="mt-0" />
                              <div
                                class="
                                  addCardFont
                                  font-semibold
                                  ml-3
                                  cursor
                                  mt-0
                                "
                              >
                                Remove
                              </div>
                            </div>
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                  </vs-col>
                  <vs-col class="p-4 pl-0 pt-0 pb-1">
                    <vs-row>
                      <div
                        class="
                          flex flex-wrap-reverse
                          items-center
                          ml-0
                          cursor
                          mt-4
                          mb-3
                          pt-0
                        "
                        @click="addPerks(index)"
                      >
                        <PlusSquareIcon color="white" />
                        <h6 class="ml-2 mt-1 cursor">Add Perks</h6>
                      </div>
                    </vs-row>
                    <vs-row
                      :key="index2"
                      v-for="(credits, index2) in credits_perks[index].perks"
                      class="mt-3"
                    >
                      <vs-col
                        vs-lg="9"
                        vs-sm="12"
                        vs-xs="12"
                        vs-type="flex"
                        vs-justify="flex-start"
                        class="addCardFont font-semibold mb-3"
                      >
                        <div class="addCardFont font-semibold">
                          Perk {{ index2 + 1 }}
                        </div>
                      </vs-col>
                      <vs-row>
                        <vs-col>
                          <!-- <vs-col vs-lg="9" class="p-2 pt-0 pl-0 pb-1"> -->
                          <!-- <vs-col class="p-4 pt-0 pl-0 pb-1"> -->
                          <vs-col
                            vs-lg="6"
                            vs-sm="9"
                            vs-xs="8"
                            class="inputContainer p-2 pt-0 pl-0 pb-1"
                          >
                            <select
                              v-if="credits_perks[index].perksList.length >= 0"
                              :class="{
                                'w-full posSelect pl-3': true,
                              }"
                              v-model="
                                credits_perks[index].perks[index2].perkId
                              "
                              @change="StackPerksChange(index, index2)"
                            >
                              <option
                                v-for="perk in credits_perks[index].perksList"
                                :key="
                                  perk.unique_perk_id
                                    ? perk.unique_perk_id
                                    : perk._id
                                "
                                :value="
                                  perk.unique_perk_id
                                    ? perk.unique_perk_id
                                    : perk._id
                                "
                              >
                                {{ perk.category }}
                              </option>
                            </select>
                          </vs-col>
                          <vs-col vs-lg="3" vs-sm="3">
                            <div
                              class="
                                flex flex-wrap-reverse
                                items-center
                                cursor
                                mt-2
                                pl-3
                              "
                              @click="removePerk(index, index2)"
                            >
                              <MinusSquareIcon color="white" class="mt-0" />
                              <div
                                class="
                                  addCardFont
                                  font-semibold
                                  ml-3
                                  cursor
                                  mt-0
                                "
                              >
                                Remove
                              </div>
                            </div>
                          </vs-col>
                        </vs-col>
                      </vs-row>
                    </vs-row>
                  </vs-col>
                  <!-- </vs-col> -->
                  <vs-col class="border-top-perk ml-0 mt-5" vs-lg="8"> </vs-col>
                </vs-row>
                <div v-show="errors.stackCreditCard.success" class="ml-0 mb-3">
                  <div id="errFont" class="dangerColor mt-3 ml-1">
                    <span>{{ errors.stackCreditCard.msg }}</span>
                  </div>
                </div>
              </vs-row>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-row>
    </div>
    <vs-row
      v-if="FinalButtonType == 'save'"
      class="pb-5 mb-5"
      vs-type="flex"
      vs-justify="flex-end"
    >
      <vs-button class="ml-3 mr-3 mt-2 px-6 mb-5 wizardBtnPad" @click="save()"
        >Save</vs-button
      >
    </vs-row>
    <vs-row
      v-if="FinalButtonType == 'approve'"
      class="pb-5 mb-5"
      vs-type="flex"
      vs-justify="flex-end"
    >
      <vs-button
        class="ml-3 mr-3 mt-2 px-6 mb-5 wizardBtnPad"
        type="filled"
        :color="actionBtnClr"
        @click="confirmDelete = true"
        >Reject</vs-button
      >
      <vs-button class="ml-3 mr-3 mt-2 px-6 mb-5 wizardBtnPad" @click="save()"
        >Approve</vs-button
      >
    </vs-row>
    <vs-row>
      <vs-popup
        class="holamundo details"
        :title="'End date'"
        :active.sync="showDetails"
      >
        <vs-row class="popupheight">
          <vs-col class="p-4 pb-1">
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-col
                  vs-lg="8"
                  vs-sm="8"
                  class="inputContainer max-height-5-24"
                >
                  <label class="ml-0">Date </label>
                </vs-col>

                <Datepicker
                  v-model="date"
                  wrapper-class="p-5 pr-0 pl-0 mt-2 pt-0 pb-0 mb-2"
                  calendar-class="posCalendar"
                  input-class="bgColorInput"
                  placeholder="MM/DD/YYYY"
                  format="MM/dd/yyyy"
                />
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col class="p-4 pb-1">
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-col
                  vs-lg="8"
                  vs-sm="8"
                  class="inputContainer max-height-5-24"
                >
                  <label class="ml-0">Time Zone </label>
                </vs-col>
                <select
                  v-if="timeZones.length >= 0"
                  :class="{
                    'w-full posSelect  pl-3': true,
                  }"
                  v-model="timeZone"
                >
                  <option
                    v-for="zone in timeZones"
                    :key="zone.value"
                    :value="zone.name"
                  >
                    {{ zone.name }}
                  </option>
                </select>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col class="p-4 pb-1">
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-col
                  vs-lg="8"
                  vs-sm="8"
                  class="inputContainer max-height-5-24"
                >
                  <label class="ml-0">Time </label>
                </vs-col>
                <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                  <vs-row>
                    <!-- <vs-input type="time" class="w-full" v-model="time" />
                  </vs-row> -->
                    <vs-input
                      type="text"
                      class="w-full"
                      v-model="time"
                      @click="openTimePicker()"
                    />
                  </vs-row>
                  <vs-row v-if="timePicker == true" class="mt-1">
                    <div style="background-color: #2c2c2e">
                      <input
                        id="change"
                        style="background-color: #2c2c2e"
                        class="timePicker"
                        type="number"
                        min="00"
                        max="12"
                        v-model="hours"
                        @change="computeHours()"
                      />
                    </div>
                    <div
                      style="
                        width: 50px;
                        font-size: 29px;
                        background-color: #343434;
                        border: none;
                        text-align: end;
                      "
                    >
                      <p style="font-size: xx-large; background-color: #343434">
                        :
                      </p>
                    </div>
                    <div style="background-color: #2c2c2e">
                      <input
                        style="background-color: #2c2c2e"
                        class="timePicker1"
                        type="number"
                        min="00"
                        max="59"
                        v-model="minutes"
                        @change="computeMinutes()"
                      />
                    </div>
                    <div>
                      <input
                        v-if="ampm == 'AM'"
                        class="timePicker2"
                        style="background-color: #2c2c2e"
                        type="button"
                        @click="changetime()"
                        v-model="ampm"
                      />
                      <input
                        v-if="ampm == 'PM'"
                        class="timePicker2"
                        style="background-color: #2c2c2e"
                        type="button"
                        @click="changetime()"
                        v-model="ampm"
                      />
                    </div>
                  </vs-row>
                </vs-col>
              </vs-col>
            </vs-row>
          </vs-col>
          <div v-show="errors.timepopup.success" class="ml-4 mb-3">
            <div id="errFont" class="dangerColor mt-3 ml-1">
              <span>{{ errors.timepopup.msg }}</span>
            </div>
          </div>
          <vs-row class="p-4" vs-justify="flex-end">
            <vs-button
              class="font-semibold"
              style="height: 40px"
              @click="closeEndtimepicker()"
              >Save</vs-button
            >
          </vs-row>
        </vs-row>
      </vs-popup>
      <vs-popup class="holamundo" title="Status" :active.sync="confirmDelete">
        <h5>Are you sure that you want to reject this promo?</h5>
        <vs-row vs-justify="flex-end">
          <vs-button @click="deletePromo" class="mr-4">Yes</vs-button>
          <vs-button @click="confirmDelete = false">No</vs-button>
        </vs-row>
      </vs-popup>
    </vs-row>
  </vs-row>
</template>

<script>
import {
  UploadCloudIcon,
  PlusSquareIcon,
  MinusSquareIcon,
} from "vue-feather-icons";
import { mixin as clickaway } from "vue-clickaway";
import Datepicker from "vuejs-datepicker";

import EventBus from "@/event-bus.js";
import Editor from "@tinymce/tinymce-vue";
import VueLoadImage from "vue-load-image";
import "viewerjs/dist/viewer.css";
import { api as viewerApi } from "v-viewer";
import Vue from "vue";
// import vsSelect from "@bit/lusaxweb.vuesax.vs-select";
// import vsIcon from "@bit/lusaxweb.vuesax.vs-icon";

// Vue.use(vsIcon);

import {
  validateUploadPhoto,
  validateAlphaNumeric,
  validateNumeric,
  validateLinkUrl,
  validateExpirationDate,
  validateTargetedStatus,
  validateBonusCategory,
  validatePromoCategory,
  validatePrimaryHashtag,
  validateHeadline,
  validateHashtagAlphaNumeric,
} from "@/views/admin/validation";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  data() {
    return {
      linkedPromos: [],
      credits_perks: [],
      creditList: [],
      perksList: [],
      hashtags: [],
      newpromoCategoryArray: [],
      promoList: [],
      promoListMain: [],
      primaryHashtagList: [],
      primaryHashtagListMain: [],
      hashtext: "",
      promoCategoryText: "",
      actionBtnClr: "#1D2024",
      confirmDelete: false,
      promo: {
        headline: "",
        startDate: "",
        endDate: "",
        timeZone: "",
        time: "",
        htLinkLabel: "",
        htLinkUrl: "",
        targetedStatus: "no",
        displayOnDash: true,
        promoAttachedToCard: false,
        photo: "",
        shortDescription: "",
        longDescription: "",
        bonusCategoryId: "",
        primaryHashtag: "",
        primaryHashtagPhoto: "",
        creatorOffset: "",
        promoUrl: "",
      },
      endDateContainer: "",
      photoChangeFlag: false,
      photoChangeFlag2: false,
      value: "",
      startDateNotAvailable: true,
      endDateNotAvailable: false,
      ampm: "PM",
      time: "11:59 PM",
      minutes: "59",
      hours: "11",
      date: "",
      timeZone: "Eastern",
      orignalDate: "",

      temphours: "",
      tempminutes: "",
      tempampm: "",

      timePicker: false,
      promoText: "",
      promoTextwithHash: "#",
      preview: "",
      previewPrimary: "",
      hashtaglist: [],
      hashtaglistshow: [],
      promoCategoryListshow: [],
      point_categoriesList: [],
      promoCategoryList: [],
      currentUserId: "",
      valuation: "",
      toggleColorList: false,
      togglePromoList: false,
      togglePromoCategoryList: false,
      togglePrimaryHashtagList: false,
      toggleCreditCardList: false,
      pagename: "",
      currentSelectedIssuer: "",
      isCardListLoaded: false,
      showDetails: false,
      image: "",
      isPhotoExisting: false,
      showStack: false,
      isStackAndPromoDataLoaded: false,
      //timezones
      timeZones: [
        {
          name: "Eastern",
          value: "America/New_York",
        },
        {
          name: "Central",
          value: "America/Chicago",
        },
        {
          name: "Mountain",
          value: "America/Denver",
        },
        {
          name: "Arizona",
          value: "America/Phoenix",
        },
        {
          name: "Pacific",
          value: "America/Los_Angeles",
        },
        {
          name: "Alaska",
          value: "America/Anchorage",
        },
        {
          name: "Hawaii",
          value: "Pacific/Honolulu",
        },
      ],

      cardsList: [],
      MaincardsList: [],
      toggleCardsList: false,

      errors: {
        promoUrl: {
          msg: "",
          success: false,
        },
        hashtags: {
          msg: "",
          success: false,
        },
        startDate: {
          msg: "",
          success: false,
        },
        endDate: {
          msg: "",
          success: false,
        },
        headline: {
          msg: "",
          success: false,
        },

        date: {
          msg: "",
          success: false,
        },
        targetedStatus: {
          msg: "",
          success: false,
        },
        cardName: {
          msg: "",
          success: false,
        },
        timeZone: {
          msg: "",
          success: false,
        },
        time: {
          msg: "",
          success: false,
        },
        shortDescription: {
          msg: "",
          success: false,
        },
        longDescription: {
          msg: "",
          success: false,
        },
        htLinkLabel: {
          msg: "",
          success: false,
        },
        htLinkUrl: {
          msg: "",
          success: false,
        },

        linkedPromo: {
          msg: "",
          success: false,
        },
        stackCreditCard: {
          msg: "",
          success: false,
        },
        primaryHashtag: {
          msg: "",
          success: false,
        },

        primaryHashtagphoto: {
          msg: "",
          success: false,
        },
        photo: {
          msg: "",
          success: false,
        },
        promoCategoryList: {
          msg: "",
          success: false,
        },
        bonusCategoryId: {
          msg: "",
          success: false,
        },
        timepopup: {
          success: false,
          msg: "",
        },

        set_issuer_once: 3,
        set_card_once: 3,
      },
      timeout: true,
      timesec: "",
      FinalButtonType: "",
      validateUploadPhoto,
      validateAlphaNumeric,
      validateNumeric,
      validateLinkUrl,
      validateExpirationDate,
      validateTargetedStatus,
      validateBonusCategory,
      validatePromoCategory,
      validatePrimaryHashtag,
      validateHeadline,
      genericErrorMessage,
      validateHashtagAlphaNumeric,
      toast,
    };
  },
  methods: {
    imageclicked(inp) {
      let image = {
        src: inp.toString(),
      };
      const $viewer = viewerApi({
        options: {
          toolbar: true,
          navbar: false,
          title: false,
          initialViewIndex: 0,
          zIndex: 99999,
        },
        images: [image],
      });
    },
    populateStackCreditCard(Cardindex, index) {
      this.credits_perks[index].cardName = this.cardsList[Cardindex].name;
      this.credits_perks[index].cardId = this.cardsList[Cardindex]._id;
      this.creditCardSelected(index);
    },

    keyupCreditCard(index) {
      if (this.timeout == true) {
        clearTimeout(this.timesec);
      }
      this.timeout = true;
      this.timesec = setTimeout(() => {
        this.filterCreditCardsList(index);
      }, 1000);
    },

    filterCreditCardsList(index) {
      this.timeout = false;
      if (this.credits_perks[index].cardName.trim() == "") {
        this.cardsList = this.MaincardsList;
      } else {
        if (this.MaincardsList && this.MaincardsList.length > 0) {
          this.cardsList = this.MaincardsList.filter((a) => {
            if (
              a._id &&
              a.name
                .toLowerCase()
                .includes(
                  this.credits_perks[index].cardName.toString().toLowerCase()
                )
            ) {
              return true;
            }
            return false;
          });
        }
      }
    },
    closeCreditCardList(index) {
      if (this.toggleCreditCardList == true) {
        if (!(index instanceof Number)) {
          this.closeCreditCardList22(index);
        }
      }
      let ab = this.closeCreditCardList;
      return ab;
    },
    async closeCreditCardList22(index) {
      if (
        index &&
        index.target &&
        index.target.disabled != false &&
        this.toggleCreditCardList == true
      ) {
        this.toggleCreditCardList = false;
        this.credits_perks.forEach((a) => {
          if (a.toggleCreditCardList == true) {
            a.toggleCreditCardList = false;
          }
        });
      }
    },
    async MaincloseCreditCardList(index) {
      if (this.credits_perks[index].toggleCreditCardList == true) {
        this.credits_perks[index].toggleCreditCardList = false;
        this.toggleCreditCardList = false;
        // if (this.cardDetails.selectedIssuer.name) {
        //   this.errors.issuerName = {
        //     msg: "",
        //     success: false,
        //   };
        // }
      }
    },

    async handleCreditCardToggle(index) {
      if (this.toggleCreditCardList != true) {
        this.credits_perks[index].toggleCreditCardList = true;
        this.toggleCreditCardList = true;
        this.filterCreditCardsList(index);
        // (this.tempIssuerHolder = this.topIssuer[index].name),
        //   this.topIssuer[index]._id;
      }
    },
    openShowDetailspopup() {
      this.temphours = this.hours;
      this.tempminutes = this.minutes;
      this.tempampm = this.ampm;
    },
    escapePressed() {
      if (this.promoTextwithHash.trim().length <= 0) {
        this.promoTextwithHash = "#";
      }
    },
    validateSecondaryHashtagtext(chip) {
      if (chip != "") {
        var letters = /^[a-z0-9]+$/i;
        if (!chip.toString().match(letters)) {
          // console.log("here");
          this.errors.hashtags = {
            msg: "Hashtag must be alphanumeric",
            success: true,
          };
          return false;
        } else {
          if (
            this.errors.hashtags.success == true &&
            this.errors.hashtags.msg.toString() ==
              "Hashtag must be alphanumeric"
          ) {
            this.errors.hashtags = {
              msg: "",
              success: false,
            };
          }
        }
      } else {
        if (
          this.errors.hashtags.success == true &&
          this.errors.hashtags.msg.toString() == "Hashtag must be alphanumeric"
        ) {
          this.errors.hashtags = {
            msg: "",
            success: false,
          };
        }
      }
    },
    validatePromoCategorytext(chip) {
      if (chip == "") {
        this.errors.promoCategoryList.success = true;
        this.errors.promoCategoryList.msg = "Promo Category cannot be empty";
      } else {
        if (this.errors.promoCategoryList.success == true) {
          this.errors.promoCategoryList.success = false;
          this.errors.promoCategoryList.msg = "";
        }
      }
    },
    validateAddPromotext(chip) {
      if (chip != "") {
        var letters = /^[a-z0-9]+$/i;
        if (!chip.toString().match(letters)) {
          this.errors.linkedPromo = {
            msg: "Hashtag must be alphanumeric",
            success: true,
          };
          return false;
        } else {
          if (
            this.errors.linkedPromo.success == true &&
            this.errors.linkedPromo.msg.toString() ==
              "Hashtag must be alphanumeric"
          ) {
            this.errors.linkedPromo = {
              msg: "",
              success: false,
            };
          }
          return true;
        }
      } else {
        if (
          this.errors.linkedPromo.success == true &&
          this.errors.linkedPromo.msg.toString() ==
            "Hashtag must be alphanumeric"
        ) {
          this.errors.linkedPromo = {
            msg: "",
            success: false,
          };
        }
        return true;
      }
    },
    addHashtags(chip) {
      var letters = /^[a-z0-9]+$/i;
      if (this.chip != "") {
        if (this.hashtags.includes(chip)) {
          this.errors.hashtags = {
            msg: "Hashtag already exists",
            success: true,
          };
        } else if (!chip.toString().match(letters)) {
          this.errors.hashtags = {
            msg: "Hashtag must be alphanumeric",
            success: true,
          };
          return false;
        } else {
          if (this.errors.hashtags.success == true) {
            this.errors.hashtags = {
              msg: "",
              success: false,
            };
          }
          this.hashtags.push(chip);
          this.hashtext = "";
          this.filterFunction("");
        }
      } else {
        this.errors.hashtags = {
          msg: "Hashtag cannot be empty",
          success: true,
        };
      }
    },
    addPromoCategoryItem(chip) {
      var letters = /^[a-z0-9]+$/i;
      if (chip != "") {
        if (this.newpromoCategoryArray.includes(chip)) {
          this.errors.promoCategoryList = {
            msg: "Promo Category already exists",
            success: true,
          };
        } else {
          if (this.errors.promoCategoryList.success == true) {
            this.errors.promoCategoryList = {
              msg: "",
              success: false,
            };
          }
          this.newpromoCategoryArray.push(chip);
          this.promoCategoryText = "";
          this.filterFunctionPromoCategory("");
        }
      } else {
        this.errors.promoCategoryList = {
          msg: "Promo Category cannot be empty",
          success: true,
        };
      }
    },
    remove(item) {
      this.hashtags.splice(this.hashtags.indexOf(item), 1);
    },
    removePromoCategory(item) {
      this.newpromoCategoryArray.splice(
        this.newpromoCategoryArray.indexOf(item),
        1
      );
    },
    async addNewPromo() {
      if (await this.isPromonotempty(this.linkedPromos)) {
        await this.linkedPromos.push({
          promoid: "",
          promoHeadline: "",
          shortDescription: "",
          isSelected: false,
        });
      }
    },
    async addCreditCard() {
      if (await this.isCreditCardnotempty()) {
        if (await this.checkCreditPerkEmptyIndexes()) {
          await this.credits_perks.push({
            cardId: "",
            cardName: "",
            perks: [],
            credits: [],
            perksList: [],
            creditsList: [],
            toggleCreditCardList: false,
          });
        }
      }
    },
    async addPerks(index) {
      // if (await this.notempty()) {

      /////////////////////////////////
      if (this.credits_perks[index].cardId.trim() != "") {
        if (
          this.credits_perks[index].perks.length <= 0 ||
          this.credits_perks[index].perks[
            this.credits_perks[index].perks.length - 1
          ].perkId.trim() != ""
        ) {
          await this.credits_perks[index].perks.push({
            perkId: "",
            isUserAdded: true,
          });
        } else {
          this.errors.stackCreditCard = {
            success: true,
            msg: "Please fill out the Perks field",
          };
        }
      } else {
        this.errors.stackCreditCard = {
          success: true,
          msg: "Please fill out the Credit Card field",
        };
      }

      ////////////////////////////////
    },
    async addCredits(index) {
      // if (await this.notempty()) {
      if (this.credits_perks[index].cardId.trim() != "") {
        if (
          this.credits_perks[index].credits.length <= 0 ||
          this.credits_perks[index].credits[
            this.credits_perks[index].credits.length - 1
          ].creditId.trim() != ""
        ) {
          await this.credits_perks[index].credits.push({
            creditId: "",
            isUserAdded: true,
          });
        } else {
          this.errors.stackCreditCard = {
            success: true,
            msg: "Please fill out the Credits field",
          };
        }
      } else {
        this.errors.stackCreditCard = {
          success: true,
          msg: "Please fill out the Credit Card field",
        };
      }
    },
    // async populateStackPromo(index) {
    //   if ((await this.isLinkedPromoUniqueID(index)) != true) {
    //     this.errors.linkedPromo = {
    //       success: true,
    //       msg: "Promo already exists",
    //     };
    //     this.linkedPromos[index].promoid = "";
    //   } else {
    //     if (this.errors.linkedPromo.success == true) {
    //       this.errors.linkedPromo = {
    //         success: false,
    //         msg: "",
    //       };
    //     }
    //     let temppromo = this.promoList.find(
    //       (a) => a._id == this.linkedPromos[index].promoid
    //     );
    //     if (temppromo) {
    //       this.linkedPromos[index].promoHeadline = temppromo.headline;
    //       this.linkedPromos[index].shortDescription =
    //         temppromo.short_description;
    //     }
    //   }
    // },
    checkphoto() {
      if (this.promo.primaryHashtag.trim() != "") {
        let temp = this.primaryHashtagListMain.find(
          (a) => a.name == this.promo.primaryHashtag
        );
        if (temp) {
          if (temp.photo) {
            this.promo.primaryHashtagPhoto = temp.photo;
            this.photoChangeFlag = false;
            this.isPhotoExisting = true;
          } else {
            this.promo.primaryHashtagPhoto = "";
            this.photoChangeFlag = false;
            this.isPhotoExisting = false;
          }
        } else {
          this.promo.primaryHashtagPhoto = "";
          this.photoChangeFlag = false;
          this.isPhotoExisting = false;
        }
      } else {
        this.promo.primaryHashtagPhoto = "";
        this.photoChangeFlag = false;
        this.isPhotoExisting = false;
      }
    },
    async populateStackPromo(index, inp) {
      if (
        (await this.validateAddPromotext(
          this.promoTextwithHash
            .toString()
            .substring(1, this.promoTextwithHash.length)
        )) == true
      ) {
        if (
          !this.promoList[index].isSelected == true ||
          (inp == "none" && !this.promoList[index].isSelected == true)
        ) {
          this.linkedPromos.push({
            promoid: this.promoList[index]._id,
            promoHeadline: this.promoList[index].headline,
            shortDescription: this.promoList[index].short_description,
          });
          if (inp == "none") {
            this.promoList[index].isSelected = true;
            Vue.set(this.promoList, index, this.promoList[index]);
          }
          // this.handlePromoList();
        } else if (inp != "none") {
          let tempIndex = this.linkedPromos.findIndex(
            (a) => a.promoid == this.promoList[index]._id
          );
          if (tempIndex >= 0) {
            this.linkedPromos.splice(tempIndex, 1);
          }
          //this.promoList[index].isSelected=false
        }
        // if ((await this.isLinkedPromoUniqueID(index)) != true) {
        //   this.errors.linkedPromo = {
        //     success: true,
        //     msg: "Promo already exists",
        //   };
        //   this.linkedPromos[index].promoid = "";
        // } else {
        //   if (this.errors.linkedPromo.success == true) {
        //     this.errors.linkedPromo = {
        //       success: false,
        //       msg: "",
        //     };
        //   }
        //   let temppromo = this.promoList.find(
        //     (a) => a._id == this.linkedPromos[index].promoid
        //   );
        //   if (temppromo) {
        //     this.linkedPromos[index].promoHeadline = temppromo.headline;
        //     this.linkedPromos[index].shortDescription =
        //       temppromo.short_description;
        //   }
        // }
      }
    },
    async checkCreditPerkEmptyIndexes() {
      this.credits_perks.forEach((data) => {
        if (data.perks.find((a) => a.perkId.trim() == "")) {
          this.errors.stackCreditCard = {
            success: true,
            msg: "Please fill out the Perks field",
          };
        }
        if (data.credits.find((a) => a.creditId.trim() == "")) {
          this.errors.stackCreditCard = {
            success: true,
            msg: "Please fill out the Credits field",
          };
        }
      });
      if (this.errors.stackCreditCard.success == true) {
        return false;
      } else {
        return true;
      }
    },

    async isLinkedPromoUniqueID(index) {
      var tmpArr = [];
      for (var i = 0; i < this.linkedPromos.length; i++) {
        if (tmpArr.indexOf(this.linkedPromos[i].promoid) < 0) {
          tmpArr.push(this.linkedPromos[i].promoid);
        } else {
          // this.error.duplicateIndices.push(i);
          // console.log("false");
          return false;
        }
      }
      // console.log("true");
      return true;
    },

    async isUniqueID(index) {
      var tmpArr = [];
      for (var i = 0; i < this.credits_perks.length; i++) {
        if (tmpArr.indexOf(this.credits_perks[i].cardId) < 0) {
          tmpArr.push(this.credits_perks[i].cardId);
        } else {
          // this.error.duplicateIndices.push(i);

          return false;
        }
      }

      return true;
    },

    async creditCardSelected(index) {
      if ((await this.isUniqueID(index)) == true) {
        if (this.errors.stackCreditCard.success == true) {
          this.errors.stackCreditCard = {
            success: false,
            msg: "",
          };
        }
        let mycard = this.cardsList.find(
          (a) => a._id == this.credits_perks[index].cardId
        );
        if (mycard) {
          this.credits_perks[index].perksList = mycard.perks;
          this.credits_perks[index].creditsList = mycard.fee_categories;
          this.credits_perks[index].perks = [];
          this.credits_perks[index].credits = [];
        }
      } else {
        this.credits_perks[index].cardId = "";
        this.credits_perks[index].cardName = "";

        this.errors.stackCreditCard = {
          success: true,
          msg: "CreditCard already exists",
        };
      }
    },
    async isCreditIDUnique(index) {
      var tmpArr = [];
      for (var i = 0; i < this.credits_perks[index].credits.length; i++) {
        if (tmpArr.indexOf(this.credits_perks[index].credits[i].creditId) < 0) {
          tmpArr.push(this.credits_perks[index].credits[i].creditId);
        } else {
          // this.error.duplicateIndices.push(i);

          return false;
        }
      }

      return true;
    },
    async StackCreditsChange(index, index1) {
      if ((await this.isCreditIDUnique(index)) == true) {
        if (this.errors.stackCreditCard.success == true) {
          this.errors.stackCreditCard = {
            success: false,
            msg: "",
          };
        }
      } else {
        this.credits_perks[index].credits[index1].creditId = "";
        this.errors.stackCreditCard = {
          success: true,
          msg: "Credit already exists",
        };
      }
    },
    async isPerkIDUnique(index) {
      var tmpArr = [];
      for (var i = 0; i < this.credits_perks[index].perks.length; i++) {
        if (tmpArr.indexOf(this.credits_perks[index].perks[i].perkId) < 0) {
          tmpArr.push(this.credits_perks[index].perks[i].perkId);
        } else {
          // this.error.duplicateIndices.push(i);

          return false;
        }
      }

      return true;
    },
    async StackPerksChange(index, index1) {
      if ((await this.isPerkIDUnique(index)) == true) {
        if (this.errors.stackCreditCard.success == true) {
          this.errors.stackCreditCard = {
            success: false,
            msg: "",
          };
        }
      } else {
        this.credits_perks[index].perks[index1].perkId = "";
        this.errors.stackCreditCard = {
          success: true,
          msg: "Perk already exists",
        };
      }
    },

    filterPromoList(promoText) {
      this.promoText = this.promoTextwithHash
        .toString()
        .substring(1, this.promoTextwithHash.length);
      if (this.promoText.trim() != "") {
        this.promoList = this.promoListMain;
      }
      let temp1 = this.promoListMain.filter((a) => {
        let temphashtag = [];
        temphashtag = a.secondary_hashtags.filter((bb) => {
          if (
            // (a.primary_hashtag_id &&
            //   a.primary_hashtag_id.name.toLowerCase().includes(this.promoText)) ||
            bb.hashtagId &&
            bb.hashtagId.name
              .toLowerCase()
              .includes(this.promoText.toLowerCase())
          ) {
            return true;
          }
          return false;
        });
        if (temphashtag && temphashtag.length > 0) {
          return temphashtag;
        }
      });
      let temp2 = this.promoListMain.filter((a) => {
        if (
          a.primary_hashtag_id &&
          a.primary_hashtag_id.name
            .toLowerCase()
            .includes(this.promoText.toLowerCase())
        ) {
          return true;
        }
        return false;
      });
      this.promoList = [...temp1];
      temp2.forEach((a) => {
        if (this.promoList.indexOf(a) == -1) {
          this.promoList.push(a);
        }
      });
    },

    changetime() {
      this.computeHours();
      this.computeMinutes();
      if (this.ampm == "AM") {
        this.ampm = "PM";
      } else {
        this.ampm = "AM";
      }
      this.time = this.hours + ":" + this.minutes + " " + this.ampm;
    },
    openTimePicker() {
      this.timePicker = !this.timePicker;
    },
    closeEndtimepicker() {
      if (this.date != "" && this.time != "" && this.timeZone != "") {
        if (this.errors.timepopup.success == true) {
          this.errors.timepopup = {
            success: false,
            msg: "",
          };
        }
        let needate = new Date(this.date);
        this.endDateContainer =
          needate.getMonth() +
          1 +
          "/" +
          needate.getDate() +
          "/" +
          needate.getFullYear();
        this.promo.timeZone = this.timeZone;
        this.promo.time = this.time;
        this.orignalDate = this.date;
        this.showDetails = false;
        this.temphours = this.hours;
        this.tempminutes = this.minutes;
        this.tempampm = this.ampm;
      } else {
        this.errors.timepopup = {
          success: true,
          msg: "Please fill out all the fields",
        };
      }
    },
    computeHours() {
      if (this.hours < 10 && this.hours == 0) {
        this.hours = "00";
      } else if (this.hours < 10 && this.hours != 0) {
        if (this.hours.length <= 1) {
          this.hours = "0" + this.hours;
        }
      }

      this.time = this.hours + ":" + this.minutes + " " + this.ampm;
    },
    computeMinutes() {
      if (this.minutes < 10 && this.minutes == 0) {
        this.minutes = "00";
      } else if (this.minutes < 10 && this.minutes != 0) {
        if (this.minutes.length <= 1) {
          this.minutes = "0" + this.minutes;
        }
      }

      this.time = this.hours + ":" + this.minutes + " " + this.ampm;
    },
    filterFunctionPromoCategory(searchfilter) {
      this.promoCategoryListshow = this.promoCategoryList.filter((a) => {
        if (a.name.toLowerCase().includes(searchfilter.toLowerCase())) {
          if (!this.newpromoCategoryArray.includes(a.name)) {
            return true;
          }
        }
        return false;
      });
    },
    filterFunction(searchfilter) {
      this.hashtaglistshow = this.hashtaglist.filter((a) => {
        if (a.name.toLowerCase().includes(searchfilter.toLowerCase())) {
          if (!this.hashtags.includes(a.name)) {
            return true;
          }
        }
        return false;
      });
    },

    filterPrimaryHashtagFunction() {
      if (this.promo.primaryHashtag.trim() != "") {
        this.primaryHashtagList = this.primaryHashtagListMain;
      } else {
        this.primaryHashtagList = [];
      }
      let tempHash = [];
      let temp2 = this.primaryHashtagListMain.filter((a) => {
        if (
          a &&
          a.name.toLowerCase().includes(this.promo.primaryHashtag.toLowerCase())
        ) {
          return true;
        }
        return false;
      });
      this.primaryHashtagList = temp2;

      this.primaryHashtagList = this.primaryHashtagList.reduce((unique, o) => {
        if (!unique.some((obj) => obj.name === o.name)) {
          unique.push(o);
        }
        return unique;
      }, []);

      // this.primaryHashtagList=this.primaryHashtagList.filter((a) => {

      //   if (this.primaryHashtagList.indexOf(a.name) == -1) {
      //     console.log("helo");
      //     //this.primaryHashtagList.push(a);
      //     return true
      //   }
      //   else{
      //     return false
      //   }
      // });
      //  console.log(this.primaryHashtagList);
    },

    showFilePath(event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.promo.photo = this.$refs.uploadAddCard.files[0];
      if (this.promo.photo) {
        this.photoChangeFlag2 = true;
        this.validateUploadPhoto(this.promo.photo);
        let format = this.$refs.uploadAddCard.files[0].type.split("/").pop();
        if (
          this.$refs.uploadAddCard.files[0].size / 1048576 >
          this.$maxFileSize
        ) {
          this.errors.photo = {
            msg: "Photo size must be less than " + this.$maxFileSize + " MB",
            success: true,
          };
        } else {
          this.errors.photo = {
            msg: "",
            success: false,
          };
          if (!this.$photoFormats.includes(format)) {
            this.errors.photo = {
              msg: "Please select a valid photo format",
              success: true,
            };
          } else {
            this.errors.photo = {
              msg: "",
              success: false,
            };
          }
        }
      } else {
        this.errors.photo = {
          msg: "Upload Photo is required",
          success: true,
        };
      }
    },

    showFilePathPrimaryHashtag(event) {
      var input = event.target;
      // console.log(input, "123");
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.previewPrimary = e.target.result;
        };
        this.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.promo.primaryHashtagPhoto = this.$refs.uploadAddCard1.files[0];
      if (this.promo.primaryHashtagPhoto) {
        this.photoChangeFlag = true;
        this.validateUploadPhoto(this.promo.primaryHashtagPhoto);
        let format = this.$refs.uploadAddCard1.files[0].type.split("/").pop();
        if (
          this.$refs.uploadAddCard1.files[0].size / 1048576 >
          this.$maxFileSize
        ) {
          this.errors.primaryHashtagphoto = {
            msg: "Photo size must be less than " + this.$maxFileSize + " MB",
            success: true,
          };
        } else {
          this.errors.primaryHashtagphoto = {
            msg: "",
            success: false,
          };
          if (!this.$photoFormats.includes(format)) {
            this.errors.primaryHashtagphoto = {
              msg: "Please select a valid photo format",
              success: true,
            };
          } else {
            this.errors.primaryHashtagphoto = {
              msg: "",
              success: false,
            };
          }
        }
      } else {
        this.errors.primaryHashtagphoto = {
          msg: "Upload Photo is required",
          success: true,
        };
      }
    },

    async isPromonotempty() {
      for (var i = 0; i < this.linkedPromos.length; i++) {
        if (
          this.linkedPromos[i].promoid == "" ||
          !this.linkedPromos[i].promoid.trim()
        ) {
          this.errors.linkedPromo = {
            msg: "Please fill out the promo field",
            success: true,
          };
          return false;
        } else {
          this.errors.linkedPromo = {
            msg: "",
            success: false,
          };
        }
      }
      return true;
    },

    async isCreditCardnotempty() {
      for (var i = 0; i < this.credits_perks.length; i++) {
        if (
          this.credits_perks[i].cardId == "" ||
          !this.credits_perks[i].cardId.trim()
        ) {
          this.errors.stackCreditCard = {
            msg: "Please fill out the Credit Card field",
            success: true,
          };
          return false;
        } else {
          this.errors.stackCreditCard = {
            msg: "",
            success: false,
          };
        }
      }
      return true;
    },

    async checkinputlink() {
      await this.validateLinkUrl(this.promo.htLinkUrl);
    },

    startDateNotAvailableSelected() {
      this.promo.startDate = "";

      this.errors.startdate = {
        msg: "",
        success: false,
      };
    },
    endDateNotAvailableSelected() {
      this.endDateContainer = "";
      this.promo.timeZone= null;
      this.promo.time = null;
      this.promo.endDate = null;

      this.errors.enddate = {
        msg: "",
        success: false,
      };
    },
    datepickerOpened() {
      this.errors.date = {
        msg: "",
        success: false,
      };
    },

    async datepickerClosed() {
      await this.validateExpirationDate(this.cardDetails.date.toString());
    },
    closeCardsList() {
      this.toggleCardsList = false;
    },

    removePromo(index) {
      if (this.errors.linkedPromo.success == true) {
        this.errors.linkedPromo = {
          success: false,
          msg: "",
        };
      }
      let tempIndex = this.promoList.findIndex(
        (a) => a._id == this.linkedPromos[index].promoid
      );
      let promo;
      if (tempIndex >= 0) {
        promo = this.promoList[tempIndex];
        promo.isSelected = false;
        Vue.set(this.promoList, tempIndex, promo);
      }
      this.linkedPromos.splice(index, 1);
    },
    removeCreditCard(index) {
      this.credits_perks.splice(index, 1);
      if (this.errors.stackCreditCard.success == true) {
        this.errors.stackCreditCard = {
          success: false,
          msg: "",
        };
      }
    },
    removePerk(index, index1) {
      this.credits_perks[index].perks.splice(index1, 1);
      if (this.errors.stackCreditCard.success == true) {
        this.errors.stackCreditCard = {
          success: false,
          msg: "",
        };
      }
    },
    removeCredit(index, index1) {
      this.credits_perks[index].credits.splice(index1, 1);
      if (this.errors.stackCreditCard.success == true) {
        this.errors.stackCreditCard = {
          success: false,
          msg: "",
        };
      }
    },

    async handleFilter() {
      this.toggleColorList = true;
    },
    async handlePrimaryHashtagFilter() {
      this.togglePrimaryHashtagList = true;
    },

    async handlePromoCategoryFilter() {
      if(this.promoCategoryListshow.length==0 && this.promoCategoryText==''){
        this.filterFunctionPromoCategory('')
      }
      this.togglePromoCategoryList = true;
    },

    async handlePromoList() {
      this.togglePromoList = true;
    },
    closeColorList() {
      if (this.toggleColorList) {
        this.toggleColorList = false;
      }
    },
    closePrimaryHashtagList() {
      if (this.togglePrimaryHashtagList) {
        this.togglePrimaryHashtagList = false;
        this.checkphoto();
      }
    },

    closePromoCategoryList() {
      if (this.togglePromoCategoryList) {
        this.togglePromoCategoryList = false;
      }
    },

    closePromoList(event) {
      //console.log(event);
      // console.log(event.target.attributes["vs-name"].nodeValue);
      if (event.target && event.target.attributes) {
        if (
          event.target.attributes["vs-name"] == undefined ||
          event.target.attributes["vs-name"].nodeValue !=
            "{promo.isSelected+index}"
        ) {
          if (
            event.target.attributes["vs-name"] == undefined ||
            event.target.attributes["vs-name"].nodeValue != "pickerRow"
          ) {
            if (this.togglePromoList) {
              this.togglePromoList = false;
            }
          }
        }
      }
    },

    // getCategories() {
    //   clearTimeout(this.timer);
    //   this.timer = setTimeout(() => {
    //     this.$vs.loading.close();
    //     this.$vs.loading({
    //       background: "rgba(1,2,3,.2)",
    //     });
    //     return new Promise((resolve, reject) => {
    //       this.$axios
    //         .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetCategories, {
    //           headers: {
    //             Authorization: this.$localStorage.get("token"),
    //           },
    //         })
    //         .then(async (res) => {
    //           // this.getCardsList();
    //           this.getPromos();
    //           this.$vs.loading.close();
    //           if (res.data.success) {
    //             resolve((this.point_categoriesList = res.data.data));
    //           } else {
    //             this.toast(this.genericErrorMessage());
    //           }
    //         })
    //         .catch((e) => {
    //           if (e.response.status !== 401) {
    //             this.toast(this.genericErrorMessage());
    //           }
    //           this.$vs.loading.close();
    //         });
    //     });
    //   }, 500);
    // },
    getPromos() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise((resolve, reject) => {
          this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetPromos)
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                resolve((this.promoList = res.data.data.promoHashtags));
                resolve((this.promoCategoryList = res.data.data.promoCategories));
                resolve((this.point_categoriesList = res.data.data.pointCategories.filter((cat)=>cat.name!=null)))
                this.MaincardsList = this.cardsList;
                this.isCardListLoaded = true;
                if (
                  this.promoList &&
                  this.promoList.hashtagList &&
                  this.promoList.hashtagList.length > 0
                ) {
                  this.hashtaglistshow = this.promoList.hashtagList;
                  this.hashtaglist = this.promoList.hashtagList;
                  this.primaryHashtagListMain =
                    this.promoList.PrimaryHashtagList;
                  this.primaryHashtagList = this.promoList.PrimaryHashtagList;
                  if (
                    this.promoList.PromoList &&
                    this.promoList.PromoList.length > 0
                  ) {
                    this.promoList = this.promoList.PromoList;

                    this.promoList = this.promoList.map((value, index) => {
                      if (!value.isSelected) {
                        let temp = this.linkedPromos.find(
                          (a) => a.promoid == value._id
                        );
                        if (temp) {
                          value.isSelected = true;
                        } else {
                          value.isSelected = false;
                        }
                      }

                      return value;
                    });
                    this.promoListMain = this.promoList;

                    //this.primaryHashtagListMain = this.promoList;
                    //            this.credits_perks = this.credits_perks.map((value, index) => {
                    //   return {
                    //     cardId: value.cardId,
                    //     credits: value.credits,
                    //     perks: value.perks,
                    //   };
                    // });
                    // this.primaryHashtagListMain =
                    //   this.primaryHashtagListMain.map((value, index) => {
                    //     return value.primary_hashtag_id;
                    //   });
                    // this.primaryHashtagList = this.primaryHashtagListMain;
                    // this.primaryHashtagList = this.primaryHashtagList.reduce(
                    //   (unique, o) => {
                    //     if (!unique.some((obj) => obj.name === o.name)) {
                    //       unique.push(o);
                    //     }
                    //     return unique;
                    //   },
                    //   []
                    // );
                  } else {
                    this.promoList = [];
                  }
                }
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
              this.$vs.loading.close();
            });
        });
      }, 1000);
    },
    getCardsAndPromos() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise((resolve, reject) => {
          this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetCardsAndPromos)
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                resolve((this.promoList = { PromoList:res.data.data.promos, hashtagList:[]}));
                resolve((this.cardsList = res.data.data.cards));
                this.MaincardsList = this.cardsList;
                this.isCardListLoaded = true;
                this.isStackAndPromoDataLoaded = true;
                this.showStack = true;
                if (
                  this.promoList &&
                  this.promoList.PromoList &&
                  this.promoList.PromoList.length > 0
                ) {
                  this.promoList = this.promoList.PromoList;

                  this.promoList = this.promoList.map((value, index) => {
                    if (!value.isSelected) {
                      let temp = this.linkedPromos.find(
                        (a) => a.promoid == value._id
                      );
                      if (temp) {
                        value.isSelected = true;
                      } else {
                        value.isSelected = false;
                      }
                    }

                    return value;
                  });
                  this.promoListMain = this.promoList;
                } else {
                  this.promoList = [];
                }
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
              this.$vs.loading.close();
            });
        });
      }, 1000);
    },
    sethours() {
      //this.date.setHours(this.hours);
      let tempHours;
      let tempMinutes;
      if (this.hours == this.temphours) {
        tempHours = this.hours;
      } else {
        tempHours = this.temphours;
      }
      if (this.minutes == this.tempminutes) {
        tempMinutes = this.minutes;
      } else {
        tempMinutes = this.tempminutes;
      }

      if (tempHours === "12") {
        tempHours = "00";
      }

      if ((this.ampm == this.tempampm ? this.ampm : this.tempampm) === "PM") {
        tempHours = parseInt(tempHours, 10) + 12;
      }

      if ((this.ampm == this.tempampm ? this.ampm : this.tempampm) === "AM") {
        tempHours = parseInt(tempHours);
      }
      tempMinutes = parseInt(tempMinutes);

      this.date.setHours(tempHours, tempMinutes);
      if (this.orignalDate != "") {
        this.orignalDate.setHours(tempHours, tempMinutes);
      }
    },
    PopulateCreditPerks() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise(async (resolve) => {
          await this.$axios
            .get(this.$ApiKeys.BASE_URL + 
            this.$EndPoints.PopulateCreditPerks.prefix +
            this.promo.bonusCategoryId +
            this.$EndPoints.PopulateCreditPerks.suffix)
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                this.showStack = true;
                let tempCrditPerk = [];
                resolve((tempCrditPerk = res.data.data));
                if (this.credits_perks.length == 0) {
                  this.credits_perks = tempCrditPerk;
                } else {
                  tempCrditPerk.forEach((data) => {
                    let mytemp = this.credits_perks.find(
                      (a) => a.cardId == data.cardId
                    );
                    if (mytemp) {
                      if (data.perks && data.perks.length > 0) {
                        if (mytemp.perks && mytemp.perks.length > 0) {
                          data.perks.forEach((dataperk) => {
                            let tempPerk = mytemp.perks.find(
                              (a) => a.perkId == dataperk.perkId
                            );
                            if (!tempPerk) {
                              mytemp.perks.push(dataperk);
                            }
                          });
                        } else {
                          mytemp.perks = data.perks;
                        }
                      }
                      if (data.credits && data.credits.length > 0) {
                        if (mytemp.credits && mytemp.credits.length > 0) {
                          data.credits.forEach((datacredit) => {
                            let tempCredit = mytemp.credits.find(
                              (a) => a.creditId == datacredit.creditId
                            );
                            if (!tempCredit) {
                              mytemp.credits.push(datacredit);
                            }
                          });
                        } else {
                          mytemp.credits = data.credits;
                        }
                      }
                    } else {
                      this.credits_perks.push(data);
                    }
                  });
                }
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
            });
        });
      }, 500);
    },
    async savePromo() {
      await this.validateHeadline(this.promo.headline);
      //await this.validateTargetedStatus(this.promo.targetedStatus);
      await this.validatePrimaryHashtag(this.promo.primaryHashtag);

      await this.validatePromoCategory(
        this.newpromoCategoryArray,
        this.promoCategoryList
      );
      // await this.validateBonusCategory(
      //   this.promo.bonusCategoryId,
      //   this.point_categoriesList
      // );

      let {
        //targetedStatus,
        //bonusCategoryId,
        promoCategoryList,
        primaryHashtag,
        headline,
      } = this.errors;
      if (
        headline.success ||
        promoCategoryList.success ||
        primaryHashtag.success
      ) {
        return false;
      } else {
        this.errors.startDate = {
          success: false,
          msg: "",
        };
        if (
          this.startDateNotAvailable == false &&
          this.promo.startDate.toString().trim() == ""
        ) {
          this.errors.startDate = {
            success: true,
            msg: "Please Enter Start Date",
          };
          return false;
        } else if (this.endDateNotAvailable == false) {
          //this.promo.endDate;
          if (this.endDateContainer.trim() == "") {
            this.errors.endDate = {
              success: true,
              msg: "Please Enter End Date",
            };
            return false;
          } else if (this.promo.time.trim() == "") {
            this.errors.endDate = {
              success: true,
              msg: "Please Enter Ending Time",
            };
            return false;
          } else if (this.promo.timeZone.trim() == "") {
            this.errors.endDate = {
              success: true,
              msg: "Please Enter Time Zone",
            };
            return false;
          } else {
            this.errors.endDate = {
              success: false,
              msg: "",
            };
            this.sethours();

            if (
              (
                this.date.getMonth() +
                1 +
                "/" +
                this.date.getDate() +
                "/" +
                this.date.getFullYear()
              ).toString() == this.endDateContainer.toString()
            ) {
              this.promo.endDate = this.date;
            } else {
              this.promo.endDate = this.orignalDate;
            }
          }
        }
        this.promo.creatorOffset = new Date().getTimezoneOffset();
        if (
          !(await this.checkCreditPerkEmptyIndexes()) ||
          !(await this.isPromonotempty()) ||
          !(await this.isCreditCardnotempty())
        ) {
          return false;
        } else {
          // this.credits_perks = this.credits_perks.map((value, index) => {
          //   return {
          //     cardId: value.cardId,
          //     credits: value.credits,
          //     perks: value.perks,
          //   };
          // });

          // this.linkedPromos = this.linkedPromos.map((value, index) => {
          //   return {
          //     promoid: value.promoid,
          //   };
          // });
          if (this.timeZone != "" && this.promo.timeZone == this.timeZone) {
            let temp = this.timeZones.find((a) => a.name == this.timeZone);
            if (temp) {
              this.promo.timeZone = temp.value;
            }
          } else {
            let temp = this.timeZones.find(
              (a) => a.name == this.promo.timeZone
            );
            if (temp) {
              this.promo.timeZone = temp.value;
            }
          }
          if (this.promo.displayOnDash != true) {
            this.promo.displayOnDash = false;
          }
          if (this.promo.promoAttachedToCard != true) {
            this.promo.promoAttachedToCard = false;
          }

          this.promo.secondaryHashtags = this.hashtags;
          this.promo.creditPerks = this.credits_perks;
          this.promo.linkedPromos = this.linkedPromos;
          this.promo.promoCategories = this.newpromoCategoryArray;
          var newform = new FormData();
          // if (this.photoChangeFlag2 == true) {
          // newform.append("photo", this.promo.photo);
          // newform.append(
          //   "islogoAdded",
          //   this.photoChangeFlag2 == true ? true : false
          // );
          // // }
          // // if (this.photoChangeFlag == true) {
          // newform.append("photo", this.promo.primaryHashtagPhoto);
          // newform.append(
          //   "isPrimaryLogoAdded",
          //   this.photoChangeFlag == true ? true : false
          // );
          // }

          if (this.photoChangeFlag == true && this.photoChangeFlag2 == false) {
            newform.append("hashtagPhoto", this.promo.primaryHashtagPhoto);
            newform.append("hashtagPhoto", this.promo.primaryHashtagPhoto);
          } else if (
            this.photoChangeFlag == false &&
            this.photoChangeFlag2 == true
          ) {
            newform.append("promoLogo", this.promo.photo);
          } else if (
            this.photoChangeFlag == true &&
            this.photoChangeFlag2 == true
          ) {
            newform.append("promoLogo", this.promo.photo);
            newform.append("hashtagPhoto", this.promo.primaryHashtagPhoto);
          }
          newform.append("isprimaryImageAdded", this.photoChangeFlag);
          newform.append("isphotoAdded", this.photoChangeFlag2);

          newform.append("promo", JSON.stringify(this.promo));
          this.$vs.loading({
            background: "rgba(1,2,3,.2)",
          });
          return new Promise(() => {
            this.$axios
              .post(
                this.$ApiKeys.BASE_URL + this.$EndPoints.AddPromo,
                newform,
                // {
                //   promo: this.promo,
                //   //photo: JSON.stringify(this.promo.photo),
                // },
              )
              .then(async (res) => {
                const errors = res.data.response && res.data.response.errors ? res.data.response.errors : null;
                if (res.data.success) {
                  this.$router.push({ name: "promos", params: { edit: true } });
                } else if (
                  errors &&
                  typeof errors==='object' &&
                  errors.promo &&
                  Object.keys(errors.promo)[0]) {
                    this.toast(errors.promo[Object.keys(errors.promo)[0]])
                  }
                  else {
                    this.toast(this.genericErrorMessage());
                  }
              })
              .catch((e) => {
                this.$vs.loading.close();
                this.toast(this.genericErrorMessage());
              })
              .finally(() => {
                this.$vs.loading.close();
              });
          });
        }
      }
    },

    async save() {
      if (
        !this.$route.params ||
        !this.$route.params.data ||
        this.$route.params.pagename === "Add Promo"
      ) {
        //console.log(this.cardDetails);
        this.savePromo();
        return;
      }

      await this.validateHeadline(this.promo.headline);
      // await this.validateTargetedStatus(this.promo.targetedStatus);
      await this.validatePrimaryHashtag(this.promo.primaryHashtag);

      await this.validatePromoCategory(
        this.newpromoCategoryArray,
        this.promoCategoryList
      );
      // await this.validateBonusCategory(
      //   this.promo.bonusCategoryId,
      //   this.point_categoriesList
      // );

      let { promoCategoryList, primaryHashtag, headline } = this.errors;
      if (
        headline.success ||
        promoCategoryList.success ||
        primaryHashtag.success
      ) {
        return false;
      } else {
        this.errors.startDate = {
          success: false,
          msg: "",
        };
        if (
          this.startDateNotAvailable == false &&
          this.promo.startDate.toString().trim() == ""
        ) {
          this.errors.startDate = {
            success: true,
            msg: "Please Enter Start Date",
          };
          return false;
        } else if (this.endDateNotAvailable == false) {
          if (this.endDateContainer.trim() == "") {
            this.errors.endDate = {
              success: true,
              msg: "Please Enter End Date",
            };
            return false;
          } else if (this.promo.time.trim() == "") {
            this.errors.endDate = {
              success: true,
              msg: "Please Enter Ending Time",
            };
            return false;
          } else if (this.promo.timeZone.trim() == "") {
            this.errors.endDate = {
              success: true,
              msg: "Please Enter Time Zone",
            };
            return false;
          } else {
            this.errors.endDate = {
              success: false,
              msg: "",
            };
            this.sethours();

            if (
              (
                this.date.getMonth() +
                1 +
                "/" +
                this.date.getDate() +
                "/" +
                this.date.getFullYear()
              ).toString() == this.endDateContainer.toString()
            ) {
              this.promo.endDate = this.date;
            } else {
              this.promo.endDate = this.orignalDate;
            }
          }
        }
        this.promo.creatorOffset = new Date().getTimezoneOffset();
        if (
          !(await this.checkCreditPerkEmptyIndexes()) ||
          !(await this.isPromonotempty()) ||
          !(await this.isCreditCardnotempty())
        ) {
          return false;
        } else {
          if (this.timeZone != "" && this.promo.timeZone == this.timeZone) {
            let temp = this.timeZones.find((a) => a.name == this.timeZone);
            if (temp) {
              this.promo.timeZone = temp.value;
            }
          }

          if (this.promo.displayOnDash != true) {
            this.promo.displayOnDash = false;
          }

          if (this.promo.promoAttachedToCard != true) {
            this.promo.promoAttachedToCard = false;
          }

          if (this.startDateNotAvailable == true) {
            this.promo.startDate = null;
          }
          if (this.endDateNotAvailable == true) {
            this.promo.endDate = null;
          }
          ////time end

          ///time end

          this.promo.secondaryHashtags = this.hashtags;
          this.promo.creditPerks = this.credits_perks;
          this.promo.linkedPromos = this.linkedPromos;
          this.promo.promoCategories = this.newpromoCategoryArray;
          var newform = new FormData();
          if (this.photoChangeFlag == true && this.photoChangeFlag2 == false) {
            newform.append("hashtagPhoto", this.promo.primaryHashtagPhoto);
            newform.append("hashtagPhoto", this.promo.primaryHashtagPhoto);
          } else if (
            this.photoChangeFlag == false &&
            this.photoChangeFlag2 == true
          ) {
            newform.append("promoLogo", this.promo.photo);
          } else if (
            this.photoChangeFlag == true &&
            this.photoChangeFlag2 == true
          ) {
            newform.append("promoLogo", this.promo.photo);
            newform.append("hashtagPhoto", this.promo.primaryHashtagPhoto);
          }
          newform.append("updatePromoDto", JSON.stringify(this.promo));

          // newform.append("photo", this.promo.primaryHashtagPhoto);

          // newform.append("promo", JSON.stringify(this.promo));

          this.$vs.loading({
            background: "rgba(1,2,3,.2)",
          });
          return new Promise(() => {
            this.$axios
              .patch(
                this.$ApiKeys.BASE_URL + this.$EndPoints.EditPromo +
                this.$route.params.data._id,
                newform
              )
              .then(async (res) => {
                 const errors = res.data.response && res.data.response.errors ? res.data.response.errors : null;
                this.$vs.loading.close();
                if (res.data.success&&!errors) {
                  //console.log("success");
                  if (this.$route.params.from != undefined) {
                    this.$router.push({
                      name: "userAddedPromos",
                    });
                  } else {
                    this.$router.push({
                      name: "promos",
                      params: { edit: true },
                    });
                  }
                }
                 else if (
                  errors &&
                  typeof errors==='object' &&
                  errors.updatePromoDto &&
                  Object.keys(errors.updatePromoDto)[0]) {
                    this.toast(errors.updatePromoDto[Object.keys(errors.updatePromoDto)[0]])
                  } else {
                  this.toast(this.genericErrorMessage());
                }
              })
              .catch((e) => {
                this.$vs.loading.close();
                if (e.response.data.errors) {
                  if (e.response.data.errors.headline) {
                    this.errors.headline = {
                      msg: e.response.data.errors.headline,
                      success: true,
                    };
                  } else {
                    this.errors.headline = {
                      msg: "",
                      success: false,
                    };
                  }
                  if (e.response.data.errors.promoCategoryId) {
                    this.errors.promoCategoryList = {
                      msg: e.response.data.errors.promoCategoryId,
                      success: true,
                    };
                  } else {
                    this.errors.promoCategoryList = {
                      msg: "",
                      success: false,
                    };
                  }
                  if (e.response.data.errors.credit_perks) {
                    this.errors.stackCreditCard = {
                      msg: e.response.data.errors.credit_perks,
                      success: true,
                    };
                  } else {
                    this.errors.stackCreditCard = {
                      msg: "",
                      success: false,
                    };
                  }
                  if (e.response.data.errors.promo) {
                    this.toast(e.response.data.errors.promo);
                  }

                  // this.$refs.wiz.changeTab(3,0);
                  // this.errors.cardName = {
                  //     msg: e.response.data.errors.card,
                  //     success: true
                  // };
                } else {
                  if (!e.response.data.errors) {
                    if (e.response.status !== 401) {
                      this.toast(this.genericErrorMessage());
                    }
                  }
                }
              });
          });
        }
      }
    },
    async deletePromo() {
      this.confirmDelete = false;

      let promoId = [this.$route.params.data._id];
      this.timer = setTimeout(() => {
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise((resolve, reject) => {
           this.$axios
              .delete(
                this.$ApiKeys.BASE_URL + this.$EndPoints.DeletePromo,
                { 
                  params:{
                    deletedUserCreated:true
                  },
                  data:promoId
                },
              )
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success == true) {
                await this.$router.push({
                  name: "userAddedPromos",
                });
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              this.$vs.loading.close();
              this.toast(this.genericErrorMessage());
            });
        });
      }, 500);
    },
  },
  created() {
    this.getPromos();
    //this.getCardsList();
    EventBus.$emit("resetToggleGroup", true);
  },
  mounted() {
    if (this.$route.params.from != undefined) {
      this.FinalButtonType = "approve";
    } else {
      this.FinalButtonType = "save";
    }
    this.pagename = this.$route.params.pagename;

    if (this.$route.params.data != undefined) {
      this.promo.headline = this.$route.params.data.headline;
      this.promo.shortDescription = this.$route.params.data.short_description;
      this.promo.longDescription = this.$route.params.data.long_description;
      this.promo.targetedStatus = this.$route.params.data.targetedSatus;
      this.promo.displayOnDash = this.$route.params.data.display_on_dash;
      this.promo.promoAttachedToCard = this.$route.params.data
        .promoAttachedToCard
        ? this.$route.params.data.promoAttachedToCard
        : false;
      this.promo.bonusCategoryId = this.$route.params.data.bonusCategoryId;
      this.promo.htLinkLabel = this.$route.params.data.ht_link_label;
      this.promo.htLinkUrl = this.$route.params.data.ht_link_url;

      if (this.promo.bonusCategoryId != undefined) {
        this.showStack = true;
      }

      if (
        this.$route.params.data.start_date &&
        this.$route.params.data.start_date != null
      ) {
        this.promo.startDate = this.$route.params.data.start_date;
        if (this.startDateNotAvailable == true) {
          this.startDateNotAvailable = false;
        }
      } else {
        this.startDateNotAvailable = true;
      }
      if (
        this.$route.params.data.end_date &&
        this.$route.params.data.end_date != null &&
        (this.$route.params.data.is_created_by == undefined ||
          this.$route.params.data.is_created_by == "admin" ||
          this.$route.params.data.is_approved_by_admin == true)
      ) {
        this.promo.time = this.$route.params.data.time;
        this.promo.timeZone = this.$route.params.data.time_zone;

        if (this.promo.timeZone != "") {
          let temp = this.timeZones.find((a) => a.value == this.promo.timeZone);
          if (temp) {
            this.promo.timeZone = temp.name;
          }
        }

        this.time = this.promo.time;

        let currentOffset = new Date().getTimezoneOffset();
        if (
          this.$route.params.data.end_date &&
          this.$route.params.data.creator_offset != currentOffset
        ) {
          this.date = new Date(this.$route.params.data.end_date);
          this.date = new Date(
            this.date.getTime() -
              this.$route.params.data.creator_offset * 60000 +
              currentOffset * 60000
          );
          // console.log("finallly->", this.date);
        } else {
          this.date = new Date(this.$route.params.data.end_date);
        }
        this.timeZone = this.promo.timeZone;

        this.hours = this.date.toLocaleString("en-US", {
          hour: "numeric",
          hour12: true,
        });

        this.hours = this.hours.split(" ")[0];

        this.ampm =
          this.date.getHours() && this.date.getHours() >= 12 ? "PM" : "AM";

        //this.hours = this.date.getHours();

        this.minutes = this.date.getMinutes().toString();
        this.closeEndtimepicker();
      } else if (
        this.$route.params.data.end_date &&
        this.$route.params.data.end_date != null &&
        this.$route.params.data.is_created_by == "user" &&
        this.$route.params.data.is_approved_by_admin == false
      ) {
        let currentOffset = new Date().getTimezoneOffset();
        if (
          this.$route.params.data.end_date &&
          this.$route.params.data.creator_offset &&
          this.$route.params.data.creator_offset != currentOffset
        ) {
          this.date = new Date(this.$route.params.data.end_date);
          this.date = new Date(
            this.date.getTime() -
              this.$route.params.data.creator_offset * 60000 +
              currentOffset * 60000
          );
          // console.log("finallly->", this.date);
        } else {
          this.date = new Date(this.$route.params.data.end_date);
        }
        // this.timeZone = this.promo.timeZone;

        // this.hours = this.date.toLocaleString("en-US", {
        //   hour: "numeric",
        //   hour12: true,
        // });

        // this.hours = this.hours.split(" ")[0];

        // this.ampm =
        //   this.date.getHours() && this.date.getHours() >= 12 ? "PM" : "AM";

        //this.hours = this.date.getHours();

        // this.minutes = this.date.getMinutes().toString();
        this.closeEndtimepicker();
      } else {
        this.endDateNotAvailable = true;
      }
      if (this.$route.params.data.screenshot != undefined) {
        this.promo.screenshot = this.$route.params.data.screenshot;
      }
      if (this.$route.params.data.promo_url != undefined) {
        this.promo.promoUrl = this.$route.params.data.promo_url;
      }
      if (this.$route.params.data.is_created_by != undefined) {
        this.promo.is_created_by = this.$route.params.data.is_created_by;
      }
      if (this.$route.params.data.is_approved_by_admin != undefined) {
        this.promo.is_approved_by_admin =
          this.$route.params.data.is_approved_by_admin;
      }
      if (this.$route.params.data.user != undefined) {
        this.promo.user = this.$route.params.data.user;
      }
      if (this.$route.params.data.profile != undefined) {
        this.promo.profile = this.$route.params.data.profile;
      }

      this.linkedPromos = [];
      this.credits_perks = [];
      this.hashtags = [];
      if (
        this.$route.params.data.linked_promos &&
        this.$route.params.data.linked_promos.length > 0 &&
        this.$route.params.data.linked_promos[0].promoId
      ) {
        this.$route.params.data.linked_promos.forEach((data) => {
          if (data.promoId) {
            this.linkedPromos.push({
              promoid: data.promoId._id,
              promoHeadline: data.promoId.headline,
              shortDescription: data.promoId.short_description,
              isSelected: true,
            });
          }
        });
      }

      if (
        this.$route.params.data.credit_perks &&
        this.$route.params.data.credit_perks.length > 0 &&
        this.$route.params.data.credit_perks[0]._id
      ) {
        // this.$route.params.data.credits_perks.forEach(data=>{
        //   this.pr
        // })
        this.credits_perks = this.$route.params.data.credit_perks;
      }

      if (this.$route.params.data.primary_hashtag_id) {
        if (this.$route.params.data.primary_hashtag_id.name) {
          this.promo.primaryHashtag =
            this.$route.params.data.primary_hashtag_id.name;
        } else {
          this.promo.primaryHashtag = "";
        }
        if (this.$route.params.data.primary_hashtag_id.photo) {
          this.promo.primaryHashtagPhoto =
            this.$route.params.data.primary_hashtag_id.photo;
        } else {
          this.promo.primaryHashtagPhoto = "";
        }
        if (this.$route.params.data.photo) {
          this.promo.photo = this.$route.params.data.photo;
        } else {
          this.promo.photo = "";
        }
      }

      if (
        this.$route.params.data.secondary_hashtags &&
        this.$route.params.data.secondary_hashtags.length > 0 &&
        this.$route.params.data.secondary_hashtags[0].hashtagId
      ) {
        this.$route.params.data.secondary_hashtags.forEach((data) => {
          this.hashtags.push(data.hashtagId.name);
        });
        this.filterFunction("");
      }

      if (
        this.$route.params.data.promoCategories &&
        this.$route.params.data.promoCategories.length > 0 &&
        this.$route.params.data.promoCategories[0].promoCategoryId
      ) {
        this.$route.params.data.promoCategories.forEach((data) => {
          this.newpromoCategoryArray.push(data.promoCategoryId.name);
        });
        this.filterFunctionPromoCategory("");
      }

      // this.getCardsList();
    }
  },
  components: {
    UploadCloudIcon,
    PlusSquareIcon,
    MinusSquareIcon,
    Datepicker,
    Editor,
    VueLoadImage,
  },
  mixins: [clickaway],
};
</script>

<style>
@import "../../../../assets/css/tinymce.css";
@import "./style.css";
@import "../../../../assets/css/add-edit-approve-card.css";
</style>
